var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 642,
    viewBox: "0 0 319 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_44154)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 642,
    fill: "#DDF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 96.4619V102.345C210.505 102.706 210.137 115.177 221.402 115.942L221.464 120.597L216.685 120.591L216.691 124.127L213.108 124.121V128.246H210.727V124.121H205.352V128.246H203.271L202.971 124.121C201.903 124.214 200.697 123.96 199.661 124.095C196.873 124.459 197.244 125.934 198.199 128.24L195.818 128.249V124.124H190.446V128.249H188.365L188.065 124.121H182.69C183.498 130.12 180.058 129.837 180.908 124.121L175.882 124.115L175.537 128.249H173.156V124.124L168.377 124.131L168.383 120.594H164.204V97.3461C164.204 97.166 163.448 96.8959 163.608 96.4619H221.457H221.46ZM197.007 98.227H168.38V104.114H197.007V98.227ZM177.925 117.064H167.188V119.417H177.925V117.064ZM191.042 117.064H180.306V119.417H191.042V117.064ZM193.726 117.064L192.834 118.527L193.726 119.417H203.267L204.16 117.955L203.267 117.064H193.726Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.126 180.661H118.148V158.875C118.148 158.771 119.063 157.822 119.346 157.692C120.374 157.206 135.714 157.069 137.44 157.399C138.092 157.523 139.536 158.429 139.536 158.875V179.764C139.536 179.947 140.288 180.224 140.129 180.661H140.126ZM127.054 159.182L119.891 159.436L118.745 166.337C120.468 166.627 119.715 165.943 120.007 164.952C120.361 163.742 120.335 161.783 121.367 160.919L127.054 159.182Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.374 108.259C117.732 108.061 113.486 108.99 112.917 107.288C112.249 105.298 113.972 104.304 113.927 103.31C113.875 102.141 112.058 98.9945 111.948 96.3869C111.106 76.6751 139.157 76.2594 137.181 97.8774C136.845 101.554 134.791 104.093 135.973 108.256H127.674L127.042 101.446L128.794 101.083L128.862 96.9584H119.377C119.513 98.147 119.128 99.6051 119.387 100.719C119.507 101.232 120.611 100.891 120.608 101.969C120.608 103.275 119.727 106.714 119.377 108.256C119.792 108.305 120.582 107.996 120.572 108.561C116.673 116.683 119.367 124.126 118.775 132.326C118.422 137.207 116.657 146.732 115.306 151.469C115.021 152.47 115.75 153.132 114.043 152.846C114.332 146.095 117.045 138.931 117.589 132.326C118.033 126.945 116.391 121.545 117.055 116.332C117.36 113.946 118.801 110.786 119.377 108.256L119.374 108.259ZM124.711 82.699C119.06 82.2606 114.779 87.0928 113.451 92.2042C115.747 90.3629 117.272 87.4078 119.675 85.6672C121.398 84.4169 123.48 84.2708 124.711 82.6958V82.699Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.942 190.6H11.5269C10.3203 188.042 13.0359 185.326 13.1919 184.282C13.2811 183.687 12.1891 182.71 12.0777 181.456C11.3008 172.712 12.7303 162.77 12.1095 153.894C13.7618 153.884 24.1883 153.658 24.3889 154.831C23.7394 163.429 25.1275 172.984 24.3889 181.456C24.2743 182.756 23.3796 183.367 23.2937 183.91C23.1854 184.602 26.0571 188.569 23.3988 189.924L19.1072 190.008V203.624H17.942V190.6Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0127 128.993V131.937H96.1462V133.115H79.0127V136.059H96.1462V137.236H79.0127V140.18H96.1462V141.358H79.0127V144.302H63.651V141.358H45.9237V140.18H63.651V137.236H45.9237V136.059H63.651V133.115H45.9237C45.8785 132.732 46.7079 131.937 46.8111 131.937H63.651V128.993H79.0127Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5199 115.603H31.2646V120.382H22.9694V106.049H11.7094V120.382H4V115.6H8.74477V98.5817C8.74477 97.652 11.9166 93.8321 12.9426 93.2547C16.917 91.0235 22.8496 92.2696 25.2479 96.2819C25.4809 96.6734 26.5231 99.0188 26.5231 99.1787V115.603H26.5199ZM17.6323 92.9122C14.1433 93.2939 11.0104 95.0782 10.5281 98.8786C12.4603 96.0177 15.2761 95.1598 17.6323 92.9122Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.053 39.7052C173.306 46.3362 173.689 52.993 172.147 59.624C167.397 57.9518 162.044 57.955 157.31 59.624C155.85 53.0059 156.395 46.3298 157.384 39.6827C162.323 38.3353 167.128 38.0716 172.053 39.7052Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51391 189.964H6.19302C5.12428 187.595 7.97637 185.145 7.91629 183.749C7.88151 182.964 6.88865 182.153 6.7432 180.824C6.44914 178.09 6.28472 155.505 7.02778 154.426L10.2498 153.87C10.5913 163.007 9.79766 172.273 10.2309 181.403C10.2909 182.654 11.2395 183.849 11.2142 184.344C11.1889 184.838 9.93047 185.934 9.7028 187.337C8.96607 191.874 10.2593 198.028 9.67435 202.698C9.53838 203.777 9.87039 203.655 8.51391 203.574V189.964Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.54 182.096V186.35C142.085 186.824 136.908 185.442 136.047 187.259V197.883H134.867V186.347H122.769L121.883 187.259V197.883H120.703V186.347H114.797L115.687 182.096H142.54Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.703 60.72C171.861 63.6586 170.203 67.2823 168.348 69.565C167.662 70.4093 166.169 70.6333 165.8 71.812C164.794 75.0169 166.996 79.6505 164.399 82.9171C161.996 85.9336 152.5 86.7551 154.223 85.0861C156.293 84.6932 161.759 83.9724 163.12 82.5534C164.481 81.1344 164.926 74.335 164.356 72.4225C164.053 71.3964 160.935 69.4546 159.761 67.4349C159.164 66.4089 157.098 61.4181 157.839 60.707C162.52 60.0868 167.039 59.7264 171.703 60.7265V60.72Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 103H244V87.7884H256.893C257.119 87.7884 257.461 86.8247 258 87.0282V103Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7092 96.9912V110.715C57.947 112.804 52.5879 104.428 51.8661 104.344C50.8048 104.217 48.5546 105.833 48.5546 106.837V120.861H47.3594V106.24C47.3594 103.773 51.569 103.477 52.565 102.779C53.6754 102 55.3573 98.6533 57.3004 97.6626C58.8124 96.8902 60.0698 96.8804 61.7092 96.9912Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1875 96.9704C88.3338 96.5301 90.0262 101.061 92.1476 102.597C93.1783 103.341 95.3396 103.465 96.1975 104.3C96.3404 104.44 97.5807 106.681 97.5807 106.825V120.861H96.3637V106.825C96.3637 106.404 92.9489 103.638 92.1542 104.173C90.9074 107.493 87.9115 110.533 84.1875 110.706V96.9704Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93 106C257.775 109.366 258.807 113.239 256.124 115.766C255.127 116.703 252.962 117.121 252.444 117.985C251.344 119.819 253.373 123.726 251.005 124C250.905 117.187 250.594 119.148 246.942 116.167C243.832 113.628 243.896 109.763 244.063 106.004H257.934L257.93 106Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.72 37.6183C167.008 36.2221 162.795 36.4179 158.064 37.6183C158.936 35.4165 159.799 33.0382 161.362 31.1926C162.189 30.2137 163.934 29.5557 164.303 28.8143C165.023 27.3636 164.764 22.9792 163.934 21.5285C162.004 18.1584 157 19.4229 154.5 17.0607C159.079 16.9066 165.001 17.985 165.727 23.2777C165.967 25.0302 165.39 27.5979 165.876 29.0037C166.136 29.7515 168.146 30.6759 169.012 31.7768C170.251 33.3527 170.86 35.8081 171.717 37.6151L171.72 37.6183Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.089 84C243.492 78.3534 245.929 75.6583 250.636 73.6535L250.976 65.0761C252.654 64.5718 252.021 66.7006 252.056 67.7175C252.124 69.6934 251.985 71.6817 252.025 73.6576C256.566 75.774 258.588 78.5766 257.852 84H244.089Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2157 112.728H13.5625V120.382H21.2157V112.728Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.317 110.336L78.5574 110.07C77.3993 109.182 78.3639 99.6873 78.0483 97.5523L81.317 96.9404V110.336Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.791 108.314C124.809 108.172 121.247 108.523 121.016 108.311L122.236 101.278L125.197 101.246C125.028 103.626 125.435 105.986 125.791 108.314C128.59 108.716 127.269 111.012 127.735 113.169C129.105 119.495 131.271 128.106 133.251 134.225C133.795 135.91 138.121 144.939 137.732 145.402C136.809 146.502 136.444 144.573 136.248 144.245C131.444 136.174 127.242 117.829 125.791 108.317V108.314Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5781 97.418L68.3124 98.1033C68.4684 101.936 68.3887 105.837 68.347 109.687L64.5781 110.335V97.418Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6139 98.8535H71.2656V108.9H74.6139V98.8535Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 184.285H252.963V138.696C250.683 136.962 243.071 136.886 240.267 137.418C238.669 137.719 237.836 139.52 237.921 141.011C239.933 141.405 245.482 141.717 246.139 143.957C246.592 145.496 243.768 152.854 242.468 153.515C240.59 154.469 233.913 154.865 232.222 153.63C231.873 153.374 229.355 147.108 229.219 146.298C228.253 140.477 234.412 142.592 236.573 141.073C237.148 140.671 236.885 136.929 239.748 136.391C241.476 136.068 249.292 136.121 251.116 136.408C251.878 136.529 254 137.612 254 138.181V184.285Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.054 187.773L236.199 187.1C225.4 186.678 230.641 181.365 231.992 174.744C235.805 175.583 239.554 174.518 243.208 175.026C243.549 177.673 246.793 181.952 245.994 184.464C245.089 187.309 239.848 186.326 238.072 187.773V196.728H237.056V187.773H237.054Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22 160.228V167.95C239.645 168.265 235.963 169.064 232.438 167.95V160.742C236.092 160.922 239.636 161.271 243.22 160.228Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.214 170.182L243.22 172.755C239.459 172.93 236.207 173.401 232.438 172.755L232.446 170.184C235.837 171.307 239.725 170.603 243.214 170.184V170.182Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.438 158.568V156.148C236.107 156.755 239.679 156.985 243.22 155.664L243.144 158C242.774 158.071 242.129 158.565 241.941 158.565H232.438V158.568Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0912 120.86H11.6562V148.129H13.0912V120.86Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1381 120.86H21.7031V148.129H23.1381V120.86Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47833 154.827H5V183.053H5.47833V154.827Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.235 159.133L121.341 160.859C120.272 161.717 120.299 163.664 119.933 164.866C119.634 165.85 120.41 166.53 118.625 166.242L119.812 159.385L127.235 159.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.839 82.6124C123.585 84.1933 121.462 84.3399 119.705 85.5948C117.255 87.3418 115.7 90.3047 113.359 92.156C114.713 87.0257 119.078 82.1757 124.839 82.6157V82.6124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8702 93.1133C11.4906 95.2759 8.64676 96.1014 6.69531 98.8542C7.18236 95.1974 10.3465 93.4805 13.8702 93.1133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.984 191.715C165.984 192.321 166.225 192.903 166.654 193.332C167.083 193.761 167.665 194.002 168.271 194.002H192.667C193.274 194.002 193.855 193.761 194.284 193.332C194.713 192.903 194.954 192.321 194.954 191.715V190.952H165.984V191.715Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.182 180.277C178.182 179.872 178.022 179.485 177.736 179.199C177.45 178.913 177.062 178.752 176.658 178.752C176.253 178.752 175.865 178.913 175.579 179.199C175.293 179.485 175.133 179.872 175.133 180.277V181.039C175.133 181.444 175.293 181.832 175.579 182.118C175.865 182.404 176.253 182.564 176.658 182.564C177.062 182.564 177.45 182.404 177.736 182.118C178.022 181.832 178.182 181.444 178.182 181.039V180.277Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.812 149.777H190.387V151.302H185.812V149.777Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.984 175.702V189.427H194.954V175.702H165.984ZM179.707 184.852C179.707 185.661 179.386 186.437 178.814 187.009C178.242 187.581 177.466 187.902 176.657 187.902C175.849 187.902 175.073 187.581 174.501 187.009C173.929 186.437 173.608 185.661 173.608 184.852H175.133C175.133 185.256 175.293 185.644 175.579 185.93C175.865 186.216 176.253 186.377 176.657 186.377C177.062 186.377 177.45 186.216 177.736 185.93C178.022 185.644 178.182 185.256 178.182 184.852V183.666C177.721 183.94 177.194 184.086 176.657 184.089C175.849 184.089 175.073 183.768 174.501 183.196C173.929 182.624 173.608 181.848 173.608 181.04V180.277C173.608 179.468 173.929 178.692 174.501 178.12C175.073 177.548 175.849 177.227 176.657 177.227C177.466 177.227 178.242 177.548 178.814 178.12C179.386 178.692 179.707 179.468 179.707 180.277V184.852ZM187.331 184.089C187.331 184.254 187.277 184.415 187.178 184.547L184.891 187.597C184.82 187.692 184.728 187.768 184.622 187.821C184.516 187.874 184.399 187.902 184.281 187.902C184.163 187.902 184.046 187.874 183.94 187.821C183.834 187.768 183.742 187.692 183.671 187.597L181.384 184.547C181.285 184.415 181.232 184.254 181.232 184.089V177.227H182.756V183.836L184.281 185.868L185.806 183.836V177.227H187.331V184.089Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.667 152.828H168.271C167.665 152.828 167.083 153.069 166.654 153.498C166.225 153.927 165.984 154.509 165.984 155.116V160.453H194.954V155.116C194.954 154.509 194.713 153.927 194.284 153.498C193.855 153.069 193.274 152.828 192.667 152.828ZM175.133 157.403H170.559V155.878H175.133V157.403ZM190.38 157.403H188.855V158.928H187.331V157.403H185.806V155.878H187.331V154.353H188.855V155.878H190.38V157.403Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.561 151.303H175.135V149.778H177.422V148.253H168.273V149.778H170.561V151.303Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.984 161.978H194.954V163.503H165.984V161.978Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.984 165.027H194.954V174.177H165.984V165.027Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5974 177.755C44.5974 167.175 53.1718 158.598 63.751 158.598C74.3302 158.598 82.9046 167.174 82.9046 177.755C82.9046 188.336 74.3302 196.911 63.751 196.911C53.1718 196.911 44.5974 188.336 44.5974 177.755ZM55.6817 176.951H62.9474V169.684C62.9474 169.241 63.3069 168.88 63.751 168.88C64.1951 168.88 64.5546 169.241 64.5546 169.684V176.951H71.8203C72.2644 176.951 72.6239 177.311 72.6239 177.755C72.6239 178.198 72.2644 178.558 71.8203 178.558H64.5546V185.824C64.5546 186.269 64.1951 186.628 63.751 186.628C63.3069 186.628 62.9474 186.269 62.9474 185.824V178.558H55.6817C55.2376 178.558 54.8781 178.199 54.8781 177.755C54.8781 177.311 55.2376 176.951 55.6817 176.951ZM63.751 160.205C54.06 160.205 46.2045 168.062 46.2045 177.755C46.2045 187.447 54.0591 195.304 63.751 195.304C73.4429 195.304 81.2975 187.449 81.2975 177.755C81.2975 168.062 73.442 160.205 63.751 160.205ZM63.751 155C51.1861 155 41 165.188 41 177.755C41 190.322 51.1861 200.509 63.751 200.509C76.3168 200.509 86.502 190.323 86.502 177.755C86.502 165.188 76.3159 155 63.751 155Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83594 17.2935V26.8735L7.53562 27.4419V16.7334L4.83594 17.2935Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83594 35.4756H7.53562V47.4297H4.83594V35.4756Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0704 7.00293H11.539C10.922 7.00293 10.3302 7.2475 9.89307 7.68309C9.45599 8.11867 9.20933 8.70976 9.20712 9.32687V11.935H4.83581C4.61414 11.935 4.40155 12.0231 4.2448 12.1799C4.08806 12.3367 4 12.5493 4 12.771C4 12.9927 4.08806 13.2053 4.2448 13.3621C4.40155 13.5189 4.61414 13.6069 4.83581 13.6069H18.9193V30.56H4.83581C4.72605 30.56 4.61737 30.5816 4.51596 30.6236C4.41456 30.6657 4.32242 30.7272 4.2448 30.8049C4.16719 30.8825 4.10563 30.9746 4.06362 31.0761C4.02162 31.1775 4 31.2862 4 31.396C4 31.5057 4.02162 31.6144 4.06362 31.7159C4.10563 31.8173 4.16719 31.9094 4.2448 31.9871C4.32242 32.0647 4.41456 32.1263 4.51596 32.1683C4.61737 32.2103 4.72605 32.2319 4.83581 32.2319H9.20712V33.536H18.9193V49.3689H9.20712V78.8779C9.20933 79.495 9.45599 80.0861 9.89307 80.5217C10.3302 80.9573 10.922 81.2019 11.539 81.2019H81.0704C81.6874 81.2019 82.2793 80.9573 82.7163 80.5217C83.1534 80.0861 83.4001 79.495 83.4023 78.8779V9.32687C83.4001 8.70976 83.1534 8.11867 82.7163 7.68309C82.2793 7.2475 81.6874 7.00293 81.0704 7.00293ZM67.5887 15.5631C67.5888 14.6841 67.8887 13.8314 68.4388 13.1459C68.9889 12.4605 69.7563 11.9832 70.6143 11.7929V10.5724C70.6143 10.3507 70.7024 10.1381 70.8591 9.98133C71.0159 9.82456 71.2285 9.73649 71.4502 9.73649C71.6718 9.73649 71.8844 9.82456 72.0412 9.98133C72.1979 10.1381 72.286 10.3507 72.286 10.5724V11.7929C73.1447 11.9818 73.913 12.4587 74.4634 13.1445C75.0137 13.8303 75.3131 14.6837 75.3116 15.5631V49.0011C75.3188 49.8847 75.0221 50.744 74.4713 51.435C73.9205 52.1259 73.1489 52.6065 72.286 52.7963V54.0168C72.286 54.2385 72.1979 54.4511 72.0412 54.6079C71.8844 54.7647 71.6718 54.8527 71.4502 54.8527C71.2285 54.8527 71.0159 54.7647 70.8591 54.6079C70.7024 54.4511 70.6143 54.2385 70.6143 54.0168V52.7963C69.7563 52.606 68.9889 52.1287 68.4388 51.4433C67.8887 50.7578 67.5888 49.9051 67.5887 49.0262V15.5631ZM58.0939 15.5631C58.0924 14.6837 58.3917 13.8303 58.9421 13.1445C59.4925 12.4587 60.2608 11.9818 61.1195 11.7929V10.5724C61.1195 10.3507 61.2076 10.1381 61.3643 9.98133C61.5211 9.82456 61.7336 9.73649 61.9553 9.73649C62.177 9.73649 62.3896 9.82456 62.5463 9.98133C62.7031 10.1381 62.7911 10.3507 62.7911 10.5724V11.7929C63.6499 11.9818 64.4182 12.4587 64.9685 13.1445C65.5189 13.8303 65.8182 14.6837 65.8168 15.5631V49.0011C65.8182 49.8805 65.5189 50.7339 64.9685 51.4197C64.4182 52.1055 63.6499 52.5824 62.7911 52.7712V53.9917C62.7911 54.2134 62.7031 54.426 62.5463 54.5828C62.3896 54.7396 62.177 54.8276 61.9553 54.8276C61.7336 54.8276 61.5211 54.7396 61.3643 54.5828C61.2076 54.426 61.1195 54.2134 61.1195 53.9917V52.7963C60.2608 52.6074 59.4925 52.1305 58.9421 51.4447C58.3917 50.759 58.0924 49.9055 58.0939 49.0262V15.5631ZM27.3108 28.1525C27.0892 28.1525 26.8766 28.0644 26.7198 27.9076C26.5631 27.7509 26.475 27.5382 26.475 27.3165C26.475 27.0948 26.5631 26.8822 26.7198 26.7254C26.8766 26.5686 27.0892 26.4806 27.3108 26.4806H29.5926V24.7669H27.3108C27.0892 24.7669 26.8766 24.6788 26.7198 24.522C26.5631 24.3653 26.475 24.1526 26.475 23.9309C26.475 23.7092 26.5631 23.4966 26.7198 23.3398C26.8766 23.183 27.0892 23.095 27.3108 23.095H29.5926V21.3813H27.3108C27.0892 21.3813 26.8766 21.2932 26.7198 21.1364C26.5631 20.9797 26.475 20.767 26.475 20.5453C26.475 20.3236 26.5631 20.111 26.7198 19.9542C26.8766 19.7974 27.0892 19.7094 27.3108 19.7094H29.5926V16.516C29.5926 15.8509 29.8568 15.213 30.327 14.7427C30.7973 14.2724 31.435 14.0082 32.1001 14.0082H35.343V11.6592C35.343 11.4375 35.4311 11.2248 35.5878 11.0681C35.7446 10.9113 35.9572 10.8232 36.1788 10.8232C36.4005 10.8232 36.6131 10.9113 36.7698 11.0681C36.9266 11.2248 37.0146 11.4375 37.0146 11.6592V13.9497H38.7364V11.6592C38.7364 11.4375 38.8245 11.2248 38.9812 11.0681C39.138 10.9113 39.3506 10.8232 39.5722 10.8232C39.7939 10.8232 40.0065 10.9113 40.1632 11.0681C40.32 11.2248 40.408 11.4375 40.408 11.6592V13.9497H42.0797V11.6592C42.0797 11.4375 42.1677 11.2248 42.3245 11.0681C42.4812 10.9113 42.6938 10.8232 42.9155 10.8232C43.1372 10.8232 43.3497 10.9113 43.5065 11.0681C43.6632 11.2248 43.7513 11.4375 43.7513 11.6592V13.9497H45.4647V11.6592C45.4647 11.4375 45.5528 11.2248 45.7095 11.0681C45.8663 10.9113 46.0789 10.8232 46.3005 10.8232C46.5222 10.8232 46.7348 10.9113 46.8915 11.0681C47.0483 11.2248 47.1363 11.4375 47.1363 11.6592V13.9497H50.3877C51.0527 13.9497 51.6904 14.2139 52.1607 14.6842C52.6309 15.1545 52.8951 15.7924 52.8951 16.4575V19.6927H55.2354C55.457 19.6927 55.6696 19.7807 55.8264 19.9375C55.9831 20.0943 56.0712 20.3069 56.0712 20.5286C56.0712 20.7503 55.9831 20.9629 55.8264 21.1197C55.6696 21.2765 55.457 21.3646 55.2354 21.3646H52.9452V23.0783H55.2354C55.457 23.0783 55.6696 23.1663 55.8264 23.3231C55.9831 23.4799 56.0712 23.6925 56.0712 23.9142C56.0712 24.1359 55.9831 24.3485 55.8264 24.5053C55.6696 24.6621 55.457 24.7502 55.2354 24.7502H52.9452V26.4639H55.2354C55.457 26.4639 55.6696 26.5519 55.8264 26.7087C55.9831 26.8655 56.0712 27.0781 56.0712 27.2998C56.0712 27.5215 55.9831 27.7341 55.8264 27.8909C55.6696 28.0477 55.457 28.1358 55.2354 28.1358H52.9452V29.8077H55.2354C55.457 29.8077 55.6696 29.8957 55.8264 30.0525C55.9831 30.2093 56.0712 30.4219 56.0712 30.6436C56.0712 30.7534 56.0496 30.8621 56.0076 30.9635C55.9656 31.0649 55.904 31.1571 55.8264 31.2347C55.7488 31.3123 55.6566 31.3739 55.5552 31.4159C55.4538 31.4579 55.3451 31.4796 55.2354 31.4796H52.9452V34.7063C52.9452 35.3714 52.6811 36.0093 52.2108 36.4796C51.7406 36.95 51.1028 37.2142 50.4378 37.2142H47.1865V39.5883C47.1865 39.81 47.0984 40.0226 46.9417 40.1794C46.7849 40.3362 46.5723 40.4242 46.3507 40.4242C46.129 40.4242 45.9164 40.3362 45.7597 40.1794C45.6029 40.0226 45.5149 39.81 45.5149 39.5883V37.3061H43.8014V39.5883C43.8014 39.81 43.7134 40.0226 43.5566 40.1794C43.3999 40.3362 43.1873 40.4242 42.9656 40.4242C42.744 40.4242 42.5314 40.3362 42.3746 40.1794C42.2179 40.0226 42.1298 39.81 42.1298 39.5883V37.3061H40.4582V39.5883C40.4582 39.81 40.3701 40.0226 40.2134 40.1794C40.0566 40.3362 39.844 40.4242 39.6224 40.4242C39.4007 40.4242 39.1881 40.3362 39.0314 40.1794C38.8746 40.0226 38.7866 39.81 38.7866 39.5883V37.3061H37.0146V39.5883C37.0146 39.81 36.9266 40.0226 36.7698 40.1794C36.6131 40.3362 36.4005 40.4242 36.1788 40.4242C35.9572 40.4242 35.7446 40.3362 35.5878 40.1794C35.4311 40.0226 35.343 39.81 35.343 39.5883V37.3061H32.1335C31.4718 37.2954 30.8403 37.0277 30.3724 36.5597C29.9044 36.0917 29.6368 35.46 29.626 34.7983V31.5632H27.3108C27.0892 31.5632 26.8766 31.4751 26.7198 31.3183C26.5631 31.1615 26.475 30.9489 26.475 30.7272C26.475 30.5055 26.5631 30.2929 26.7198 30.1361C26.8766 29.9793 27.0892 29.8913 27.3108 29.8913H29.5926V28.2193L27.3108 28.1525ZM50.8056 48.8255C50.8056 49.0472 50.7175 49.2599 50.5608 49.4166C50.404 49.5734 50.1914 49.6615 49.9697 49.6615H44.4032C44.1816 49.6615 43.969 49.5734 43.8122 49.4166C43.6555 49.2599 43.5674 49.0472 43.5674 48.8255C43.5674 48.6038 43.6555 48.3912 43.8122 48.2344C43.969 48.0776 44.1816 47.9896 44.4032 47.9896H49.9697C50.1914 47.9896 50.404 48.0776 50.5608 48.2344C50.7175 48.3912 50.8056 48.6038 50.8056 48.8255ZM41.9627 48.8255C41.9627 49.0472 41.8746 49.2599 41.7178 49.4166C41.5611 49.5734 41.3485 49.6615 41.1268 49.6615H38.9955C38.7738 49.6615 38.5613 49.5734 38.4045 49.4166C38.2478 49.2599 38.1597 49.0472 38.1597 48.8255C38.1597 48.6038 38.2478 48.3912 38.4045 48.2344C38.5613 48.0776 38.7738 47.9896 38.9955 47.9896H41.1268C41.3485 47.9896 41.5611 48.0776 41.7178 48.2344C41.8746 48.3912 41.9627 48.6038 41.9627 48.8255ZM36.2373 48.8255C36.2373 49.0472 36.1493 49.2599 35.9925 49.4166C35.8358 49.5734 35.6232 49.6615 35.4015 49.6615H33.2702C33.0485 49.6615 32.8359 49.5734 32.6792 49.4166C32.5224 49.2599 32.4344 49.0472 32.4344 48.8255C32.4344 48.6038 32.5224 48.3912 32.6792 48.2344C32.8359 48.0776 33.0485 47.9896 33.2702 47.9896H35.4015C35.6232 47.9896 35.8358 48.0776 35.9925 48.2344C36.1493 48.3912 36.2373 48.6038 36.2373 48.8255ZM24.4273 47.9896H29.9938C30.2155 47.9896 30.4281 48.0776 30.5848 48.2344C30.7416 48.3912 30.8296 48.6038 30.8296 48.8255C30.8296 49.0472 30.7416 49.2599 30.5848 49.4166C30.4281 49.5734 30.2155 49.6615 29.9938 49.6615H24.4273C24.2056 49.6615 23.993 49.5734 23.8363 49.4166C23.6795 49.2599 23.5915 49.0472 23.5915 48.8255C23.5915 48.6038 23.6795 48.3912 23.8363 48.2344C23.993 48.0776 24.2056 47.9896 24.4273 47.9896ZM16.9551 72.9343C16.041 72.9277 15.1494 72.6501 14.393 72.1366C13.6366 71.6232 13.0494 70.8969 12.7057 70.0497C12.362 69.2025 12.2772 68.2724 12.4621 67.377C12.6469 66.4816 13.0931 65.6611 13.7441 65.0193C14.3952 64.3775 15.2219 63.9431 16.1197 63.7713C17.0176 63.5994 17.9462 63.6976 18.7882 64.0536C19.6302 64.4096 20.3478 65.0073 20.8502 65.7711C21.3526 66.535 21.6172 67.4307 21.6106 68.345C21.5996 69.5703 21.1034 70.7414 20.2308 71.6016C19.3582 72.4618 18.1803 72.941 16.9551 72.9343ZM16.9551 62.4933C16.041 62.4933 15.1473 62.2222 14.3872 61.7142C13.6271 61.2063 13.0347 60.4843 12.6849 59.6396C12.3351 58.7949 12.2435 57.8654 12.4219 56.9686C12.6002 56.0719 13.0404 55.2482 13.6868 54.6017C14.3332 53.9552 15.1568 53.5149 16.0534 53.3365C16.95 53.1582 17.8793 53.2497 18.7239 53.5996C19.5685 53.9495 20.2903 54.542 20.7982 55.3022C21.3061 56.0624 21.5772 56.9562 21.5772 57.8705C21.575 59.0959 21.0873 60.2704 20.221 61.1369C19.3546 62.0033 18.1803 62.4911 16.9551 62.4933ZM52.3602 69.7661H51.1482C50.9552 70.6228 50.4773 71.3886 49.7925 71.9383C49.1078 72.4881 48.2568 72.7891 47.3787 72.7922H28.4893C27.6123 72.7887 26.7625 72.4874 26.0792 71.9376C25.3958 71.3878 24.9195 70.6221 24.7282 69.7661H23.4995C23.2779 69.7661 23.0653 69.678 22.9085 69.5212C22.7518 69.3645 22.6637 69.1518 22.6637 68.9301C22.6637 68.7084 22.7518 68.4958 22.9085 68.339C23.0653 68.1822 23.2779 68.0942 23.4995 68.0942H24.7282C24.9181 67.2374 25.3941 66.4709 26.0777 65.9209C26.7614 65.3708 27.6119 65.07 28.4893 65.068H47.3787C48.2572 65.0696 49.1089 65.3701 49.794 65.9201C50.479 66.47 50.9566 67.2367 51.1482 68.0942H52.3602C52.5818 68.0942 52.7944 68.1822 52.9512 68.339C53.1079 68.4958 53.196 68.7084 53.196 68.9301C53.196 69.1518 53.1079 69.3645 52.9512 69.5212C52.7944 69.678 52.5818 69.7661 52.3602 69.7661ZM28.4893 62.3846C27.6131 62.3831 26.7634 62.0835 26.0799 61.5351C25.3964 60.9867 24.9197 60.2221 24.7282 59.3669H23.4995C23.2779 59.3669 23.0653 59.2788 22.9085 59.122C22.7518 58.9652 22.6637 58.7526 22.6637 58.5309C22.6637 58.3092 22.7518 58.0966 22.9085 57.9398C23.0653 57.783 23.2779 57.695 23.4995 57.695H24.7282C24.9178 56.8374 25.3935 56.0698 26.077 55.5184C26.7605 54.9669 27.6112 54.6644 28.4893 54.6605H56.7315C57.6096 54.6644 58.4603 54.9669 59.1438 55.5184C59.8273 56.0698 60.303 56.8374 60.4926 57.695H61.7046C61.9262 57.695 62.1388 57.783 62.2956 57.9398C62.4523 58.0966 62.5404 58.3092 62.5404 58.5309C62.5404 58.7526 62.4523 58.9652 62.2956 59.122C62.1388 59.2788 61.9262 59.3669 61.7046 59.3669H60.4926C60.3011 60.2221 59.8244 60.9867 59.1409 61.5351C58.4574 62.0835 57.6077 62.3831 56.7315 62.3846H28.4893ZM78.5211 71.9563C78.7428 71.9563 78.9554 72.0443 79.1122 72.2011C79.2689 72.3579 79.357 72.5705 79.357 72.7922C79.357 73.0139 79.2689 73.2266 79.1122 73.3833C78.9554 73.5401 78.7428 73.6282 78.5211 73.6282H77.4012V77.5822H61.1279V73.6282H60.0079C59.7862 73.6282 59.5736 73.5401 59.4169 73.3833C59.2601 73.2266 59.1721 73.0139 59.1721 72.7922C59.1721 72.5705 59.2601 72.3579 59.4169 72.2011C59.5736 72.0443 59.7862 71.9563 60.0079 71.9563H61.1279V66.9406H60.0079C59.7862 66.9406 59.5736 66.8525 59.4169 66.6957C59.2601 66.539 59.1721 66.3263 59.1721 66.1046C59.1721 65.8829 59.2601 65.6703 59.4169 65.5135C59.5736 65.3567 59.7862 65.2687 60.0079 65.2687H61.1279V61.2979H77.4012V65.2519H78.5211C78.7428 65.2519 78.9554 65.34 79.1122 65.4968C79.2689 65.6536 79.357 65.8662 79.357 66.0879C79.357 66.3096 79.2689 66.5222 79.1122 66.679C78.9554 66.8358 78.7428 66.9238 78.5211 66.9238H77.4012V71.9396L78.5211 71.9563ZM80.059 54.0168C80.059 54.2385 79.971 54.4511 79.8142 54.6079C79.6575 54.7647 79.4449 54.8527 79.2232 54.8527C79.0016 54.8527 78.789 54.7647 78.6322 54.6079C78.4755 54.4511 78.3874 54.2385 78.3874 54.0168V44.1024C78.3874 43.8807 78.4755 43.6681 78.6322 43.5113C78.789 43.3545 79.0016 43.2665 79.2232 43.2665C79.4449 43.2665 79.6575 43.3545 79.8142 43.5113C79.971 43.6681 80.059 43.8807 80.059 44.1024V54.0168ZM80.059 38.1337C80.059 38.3554 79.971 38.5681 79.8142 38.7248C79.6575 38.8816 79.4449 38.9697 79.2232 38.9697C79.0016 38.9697 78.789 38.8816 78.6322 38.7248C78.4755 38.5681 78.3874 38.3554 78.3874 38.1337V11.1827C78.3874 10.961 78.4755 10.7483 78.6322 10.5916C78.789 10.4348 79.0016 10.3467 79.2232 10.3467C79.4449 10.3467 79.6575 10.4348 79.8142 10.5916C79.971 10.7483 80.059 10.961 80.059 11.1827V38.1337Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1327 35.6338H50.3869C50.6085 35.6338 50.8211 35.5457 50.9779 35.389C51.1346 35.2322 51.2227 35.0196 51.2227 34.7979V16.5156C51.2227 16.2939 51.1346 16.0813 50.9779 15.9245C50.8211 15.7678 50.6085 15.6797 50.3869 15.6797H32.1327C31.911 15.6797 31.6984 15.7678 31.5417 15.9245C31.3849 16.0813 31.2969 16.2939 31.2969 16.5156V34.7561C31.2966 34.9818 31.3833 35.199 31.539 35.3624C31.6946 35.5259 31.9073 35.6231 32.1327 35.6338ZM33.9882 20.5867C33.9882 20.2874 34.0473 19.9911 34.162 19.7146C34.2768 19.4382 34.445 19.1872 34.657 18.9759C34.869 18.7647 35.1206 18.5974 35.3974 18.4836C35.6742 18.3698 35.9707 18.3118 36.27 18.3129H46.2997C46.9034 18.3129 47.4826 18.5522 47.9102 18.9784C48.3379 19.4046 48.5793 19.9829 48.5815 20.5867V30.6181C48.5793 31.2227 48.3382 31.8019 47.9108 32.2294C47.4833 32.6569 46.9042 32.8981 46.2997 32.9003H36.27C35.6648 32.9003 35.0844 32.6598 34.6565 32.2318C34.2286 31.8039 33.9882 31.2234 33.9882 30.6181V20.5867Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2711 20.0107H36.2664C35.9294 20.0107 35.6562 20.284 35.6562 20.621V30.6273C35.6562 30.9643 35.9294 31.2375 36.2664 31.2375H46.2711C46.6081 31.2375 46.8812 30.9643 46.8812 30.6273V20.621C46.8812 20.284 46.6081 20.0107 46.2711 20.0107Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 15.2793H17.2515V28.8802H9.21094V15.2793Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 35.208H17.2515V47.6971H9.21094V35.208Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9555 51.2163C62.2426 51.2174 62.5272 51.1618 62.7928 51.0526C63.0585 50.9434 63.2999 50.7829 63.5034 50.5802C63.7069 50.3775 63.8683 50.1366 63.9784 49.8713C64.0886 49.6061 64.1453 49.3217 64.1453 49.0345V15.5964C64.1453 15.0156 63.9146 14.4585 63.5039 14.0477C63.0932 13.637 62.5362 13.4062 61.9555 13.4063C61.3747 13.4062 60.8177 13.637 60.407 14.0477C59.9963 14.4585 59.7656 15.0156 59.7656 15.5964V49.0345C59.7678 49.6139 59.9995 50.1688 60.41 50.5777C60.8204 50.9867 61.3761 51.2163 61.9555 51.2163Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7288 56.332H28.4867C27.9059 56.332 27.3489 56.5628 26.9383 56.9735C26.5276 57.3843 26.2969 57.9413 26.2969 58.5222C26.2969 59.1031 26.5276 59.6602 26.9383 60.0709C27.3489 60.4817 27.9059 60.7124 28.4867 60.7124H56.7288C57.3096 60.7124 57.8666 60.4817 58.2773 60.0709C58.688 59.6602 58.9187 59.1031 58.9187 58.5222C58.9187 57.9413 58.688 57.3843 58.2773 56.9735C57.8666 56.5628 57.3096 56.332 56.7288 56.332Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3815 66.7483H28.4921C27.9358 66.7827 27.4136 67.028 27.0318 67.4342C26.65 67.8404 26.4375 68.3769 26.4375 68.9343C26.4375 69.4918 26.65 70.0283 27.0318 70.4345C27.4136 70.8406 27.9358 71.0859 28.4921 71.1203H47.3815C47.6799 71.1388 47.9789 71.096 48.2601 70.9945C48.5413 70.8929 48.7988 70.7349 49.0166 70.5301C49.2344 70.3253 49.408 70.0781 49.5267 69.8036C49.6453 69.5292 49.7066 69.2333 49.7066 68.9343C49.7066 68.6353 49.6453 68.3395 49.5267 68.065C49.408 67.7906 49.2344 67.5433 49.0166 67.3385C48.7988 67.1337 48.5413 66.9757 48.2601 66.8742C47.9789 66.7727 47.6799 66.7299 47.3815 66.7483Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4471 51.2168C71.7343 51.2179 72.0188 51.1622 72.2845 51.0531C72.5501 50.9439 72.7916 50.7834 72.995 50.5807C73.1985 50.378 73.3599 50.1371 73.4701 49.8718C73.5802 49.6066 73.6369 49.3222 73.6369 49.0349V15.5969C73.6025 15.0405 73.3573 14.5182 72.9512 14.1364C72.5451 13.7546 72.0087 13.542 71.4513 13.542C70.8939 13.542 70.3575 13.7546 69.9514 14.1364C69.5453 14.5182 69.3 15.0405 69.2656 15.5969V49.0349C69.2656 49.6136 69.4955 50.1686 69.9046 50.5777C70.3137 50.9869 70.8685 51.2168 71.4471 51.2168Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7969 62.9785H75.7269V75.9107H62.7969V62.9785Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9895 60.8471C18.619 60.8471 19.9399 59.526 19.9399 57.8962C19.9399 56.2665 18.619 54.9453 16.9895 54.9453C15.36 54.9453 14.0391 56.2665 14.0391 57.8962C14.0391 59.526 15.36 60.8471 16.9895 60.8471Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9895 71.2543C18.619 71.2543 19.9399 69.9332 19.9399 68.3034C19.9399 66.6737 18.619 65.3525 16.9895 65.3525C15.36 65.3525 14.0391 66.6737 14.0391 68.3034C14.0391 69.9332 15.36 71.2543 16.9895 71.2543Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.955 16.855C211.311 16.855 212.41 15.7557 212.41 14.3997C212.41 13.0436 211.311 11.9443 209.955 11.9443C208.599 11.9443 207.5 13.0436 207.5 14.3997C207.5 15.7557 208.599 16.855 209.955 16.855Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.547 14.3994H194.002V20.5377H191.547V14.3994Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.922 14.3994H228.377V20.5377H225.922V14.3994Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.547 7.0332V11.9438H195.229C195.908 11.9438 196.457 12.4926 196.457 13.1715V21.7651C196.457 22.444 195.908 22.9928 195.229 22.9928H191.547V43.863H228.371V22.9928H224.688C224.01 22.9928 223.461 22.444 223.461 21.7651V13.1715C223.461 12.4926 224.01 11.9438 224.688 11.9438H228.371V7.0332H191.547ZM209.959 19.3098C207.251 19.3098 205.049 17.1074 205.049 14.3992C205.049 11.6909 207.251 9.48852 209.959 9.48852C212.667 9.48852 214.869 11.6909 214.869 14.3992C214.869 17.1074 212.667 19.3098 209.959 19.3098Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.5 53.6843H208.727V80.6929H211.182V53.6843H212.41V46.3184H207.5V53.6843Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 53.6843H195.227V80.6929H197.682V53.6843H198.91V46.3184H194V53.6843Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 53.6843H222.227V80.6929H224.682V53.6843H225.91V46.3184H221V53.6843Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.935 28.0784H114.794V29.7717H122.935V28.0784ZM114.687 26.7667H123.046C123.701 26.7667 124.241 27.3114 124.241 27.9718V29.8848C124.241 30.5453 123.701 31.09 123.046 31.09H114.687C114.033 31.09 113.493 30.5453 113.493 29.8848V27.9718C113.494 27.3101 114.034 26.7667 114.687 26.7667ZM111.113 40.4865V49.2318L114.097 53.3157V40.4865H111.113ZM111.113 34.0161V39.1696H114.097V34.0161H111.113ZM122.333 39.1709V34.0161H115.401V39.1696H122.333V39.1709ZM127.922 40.4865V49.4489C127.922 49.5831 127.882 49.7173 127.797 49.837L123.535 55.6668C123.144 56.2417 122.334 55.9391 122.334 55.3168V40.4865H115.402V55.3155C115.402 55.9378 114.588 56.2404 114.197 55.6655L109.938 49.8357C109.853 49.716 109.812 49.5818 109.812 49.4476H109.808V40.4852H97.1016V64.887H140.629V40.4865H127.922ZM123.634 40.4865V53.3157L126.618 49.2318V40.4865H123.634ZM123.634 34.0161V39.1696H126.618V34.0161H123.634ZM128.418 7H109.313C108.644 7 108.093 7.55521 108.093 8.23016V23.8341H129.643V8.23016C129.643 7.55521 129.091 7 128.418 7ZM129.379 25.151H108.352L110.925 32.703H126.806L129.379 25.151ZM110.998 8.51039H126.732C127.09 8.51039 127.383 8.80511 127.383 9.17086V21.6645C127.383 22.0303 127.09 22.325 126.732 22.325H110.998C110.639 22.325 110.347 22.0303 110.347 21.6645V9.17086C110.348 8.80511 110.639 8.51039 110.998 8.51039ZM123.949 21.008L123.66 19.8673C123.457 19.0542 122.514 18.4056 121.664 18.4056H116.07C115.216 18.4056 114.273 19.0542 114.069 19.8673L113.781 21.008H123.949ZM117.742 17.0886L115.775 13.6494C115.35 12.9034 116.474 12.2469 116.899 12.9968L119.239 17.0886H121.665C123.1 17.0886 124.575 18.1438 124.925 19.5463L125.295 21.008H126.082V9.82738H111.653V21.008H112.44L112.807 19.5463C113.162 18.1438 114.637 17.0886 116.071 17.0886H117.742Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.558 90.2174C300.759 88.9103 299.943 87.6129 299.128 86.3156C298.012 86.9026 296.772 87.2106 295.503 87.2106C294.233 87.2106 292.994 86.9027 291.878 86.3156C291.063 87.6129 290.247 88.9103 289.448 90.2174C289.156 90.0758 288.83 89.9997 288.489 89.9997H283.391L288.153 82.0817C287.832 81.2156 287.668 80.3004 287.668 79.3743V71.5381H303.338V79.3743C303.338 80.3004 303.174 81.2156 302.853 82.0817L307.615 89.9997H302.517C302.176 89.9997 301.85 90.0758 301.558 90.2174ZM295.503 76.5533C293.945 76.5533 292.682 77.8163 292.682 79.3743C292.682 80.9324 293.945 82.1955 295.503 82.1955C297.061 82.1955 298.324 80.9324 298.324 79.3743C298.324 77.8163 297.061 76.5533 295.503 76.5533Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.633 70.183L300.31 59C300.31 59 304.266 64.3967 303.586 70.183H298.633Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.367 70.183L290.69 59C290.69 59 286.734 64.3967 287.415 70.183H292.367Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.628 91.3545H302.514C302.208 91.3545 301.945 91.5058 301.791 91.7705C301.638 92.0352 301.636 92.3385 301.788 92.6045C302.919 94.5869 304.027 96.5642 304.96 98.6629C306.795 102.791 307.77 106.913 308.315 111.389C308.499 112.899 308.587 114.614 308.349 116.117C308.194 117.1 308.463 118.054 309.109 118.811C309.756 119.568 310.656 119.983 311.651 119.983H312.463C314.116 119.983 315.511 118.789 315.766 117.155C316.105 114.976 316.045 112.68 315.779 110.495C315.122 105.094 313.908 100.197 311.615 95.2527C311.141 94.2292 310.63 93.2353 310.105 92.2436C309.808 91.6823 309.263 91.3545 308.628 91.3545ZM288.486 91.3545H282.372C281.737 91.3545 281.192 91.6823 280.895 92.2436C280.37 93.2353 279.859 94.2292 279.385 95.2527C277.092 100.197 275.878 105.094 275.221 110.495C274.955 112.68 274.895 114.976 275.234 117.155C275.489 118.789 276.884 119.983 278.537 119.983H279.349C280.344 119.983 281.244 119.568 281.891 118.811C282.537 118.054 282.806 117.1 282.651 116.117C282.413 114.614 282.501 112.899 282.685 111.389C283.23 106.913 284.205 102.791 286.04 98.6629C286.973 96.5642 288.081 94.5869 289.212 92.6045C289.363 92.3385 289.362 92.0352 289.209 91.7705C289.055 91.5058 288.792 91.3545 288.486 91.3545Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6562 217.574H66.958V221.952H56.6562V217.574Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.953 221.848C92.2699 221.844 92.5749 221.716 92.801 221.49C93.0271 221.263 93.1559 220.958 93.159 220.641L93.1766 218.66C93.179 218.343 93.0556 218.04 92.8335 217.818C92.6113 217.596 92.3086 217.473 91.9916 217.475L76.1349 217.615L76.0963 221.988L91.953 221.848Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.243 221.288L7.90747 223.123L15.243 224.957L15.243 221.288Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4372 238.948C42.4951 241.235 40.8503 244.185 38.1833 246.063C40.2879 247.178 44.2405 248.711 48.9034 247.787C48.827 246.748 48.6193 245.723 48.285 244.734C47.447 242.245 45.6022 240.363 43.4372 238.948Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3216 261.189L59.3451 241.71C59.3481 239.113 60.7575 235.644 67.453 233.864C69.522 233.337 71.6374 233.015 73.7684 232.902L73.7902 214.91L69.4055 214.915L69.3958 223.043C69.3954 223.361 69.2687 223.666 69.0436 223.892C68.8185 224.117 68.5134 224.243 68.1955 224.244L55.4784 224.259C55.3209 224.259 55.165 224.229 55.0196 224.168C54.8742 224.108 54.7422 224.02 54.631 223.909C54.5198 223.798 54.4316 223.666 54.3715 223.52C54.3114 223.375 54.2806 223.219 54.2808 223.061L54.2917 214.085L28.7604 214.116L22.2918 218.972C22.0842 219.128 21.8317 219.212 21.5723 219.212L17.6842 219.217L17.6749 226.994L21.5628 226.99C21.8222 226.989 22.0746 227.073 22.2819 227.229L26.4759 230.372L27.015 230.776L20.0301 235.148L17.3168 232.434C17.0923 232.209 16.7874 232.083 16.4695 232.084C16.1515 232.084 15.8463 232.211 15.6212 232.436C15.3961 232.661 15.2694 232.966 15.269 233.284C15.2686 233.602 15.3946 233.907 15.6192 234.132L19.0063 237.52C19.1977 237.711 19.4487 237.832 19.7181 237.863C19.9875 237.893 20.2596 237.831 20.4898 237.687L29.3553 232.139C33.2413 232.477 47.4925 234.357 50.6581 243.886C52.156 248.395 51.3755 253.292 48.4007 258.047C47.2749 259.831 45.9474 261.48 44.4445 262.962L50.4906 269.009L57.7165 264.185C58.2101 263.856 58.615 263.411 58.895 262.888C59.1751 262.365 59.3216 261.782 59.3216 261.189ZM38.5181 227.671C38.3607 227.672 38.2048 227.641 38.0594 227.581C37.914 227.521 37.7819 227.432 37.6707 227.321C37.5595 227.21 37.4714 227.078 37.4113 226.933C37.3512 226.787 37.3204 226.631 37.3206 226.474L37.3267 221.386C37.3291 221.069 37.4566 220.766 37.6815 220.542C37.9064 220.319 38.2105 220.193 38.5272 220.193C38.8439 220.192 39.1476 220.317 39.372 220.54C39.5963 220.763 39.7231 221.066 39.7246 221.383L39.7185 226.471C39.7181 226.789 39.5914 227.094 39.3663 227.319C39.1412 227.544 38.8361 227.671 38.5181 227.671ZM43.605 227.665C43.4475 227.665 43.2916 227.635 43.1463 227.575C43.0008 227.514 42.8688 227.426 42.7576 227.315C42.6464 227.204 42.5582 227.072 42.4981 226.926C42.4381 226.781 42.4072 226.625 42.4074 226.468L42.4136 221.38C42.4159 221.063 42.5434 220.76 42.7684 220.536C42.9933 220.313 43.2973 220.187 43.614 220.187C43.9307 220.186 44.2345 220.311 44.4588 220.534C44.6832 220.757 44.81 221.06 44.8115 221.377L44.8053 226.465C44.8049 226.783 44.6782 227.088 44.4531 227.313C44.228 227.538 43.923 227.665 43.605 227.665ZM48.6918 227.659C48.5344 227.659 48.3785 227.629 48.2331 227.568C48.0877 227.508 47.9556 227.42 47.8444 227.309C47.7332 227.198 47.645 227.066 47.585 226.92C47.5249 226.775 47.4941 226.619 47.4943 226.461L47.5004 221.374C47.5027 221.057 47.6303 220.754 47.8552 220.53C48.0801 220.307 48.3841 220.181 48.7009 220.18C49.0176 220.18 49.3213 220.305 49.5457 220.528C49.77 220.751 49.8968 221.054 49.8983 221.371L49.8922 226.459C49.8918 226.777 49.7651 227.082 49.54 227.307C49.3149 227.532 49.0098 227.659 48.6918 227.659Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.741 144.595L292.849 146.928C292.515 147.137 292.088 147.013 291.895 146.651C291.703 146.288 291.817 145.825 292.151 145.616L296.116 143.239C296.092 143.09 296.08 142.936 296.08 142.779C296.08 141.312 297.177 140.121 298.529 140.121C299.881 140.121 300.978 141.312 300.978 142.779C300.978 144.246 299.881 145.437 298.529 145.437C297.824 145.437 297.188 145.113 296.741 144.595ZM272.342 161.186V177.597L270.449 177.046C269.407 176.743 268.788 175.579 269.067 174.449L272.342 161.186ZM292.21 183.374H307.334L306.827 185.428C306.548 186.558 305.475 187.23 304.433 186.927L292.21 183.374ZM312.658 161.814V145.403L314.551 145.954C315.593 146.257 316.212 147.421 315.933 148.551L312.658 161.814ZM292.79 139.626H277.666L278.173 137.572C278.452 136.442 279.525 135.77 280.567 136.073L292.79 139.626ZM302.067 141.142H309.385C310.421 141.142 311.262 142.054 311.262 143.178V179.822C311.262 180.946 310.421 181.858 309.385 181.858H275.615C274.579 181.858 273.738 180.946 273.738 179.822V143.178C273.738 142.054 274.579 141.142 275.615 141.142H294.991C294.853 141.493 294.757 141.869 294.713 142.261L291.453 144.303C290.452 144.93 290.108 146.322 290.686 147.408C291.264 148.495 292.546 148.867 293.547 148.24L296.551 146.358C297.129 146.735 297.806 146.952 298.529 146.952C300.652 146.952 302.375 145.082 302.375 142.779C302.375 142.198 302.265 141.645 302.067 141.142ZM281.7 167.22H303.3C303.685 167.22 303.998 166.88 303.998 166.462C303.998 166.044 303.685 165.705 303.3 165.705H281.7C281.315 165.705 281.002 166.044 281.002 166.462C281.002 166.88 281.315 167.22 281.7 167.22ZM279.464 160.88H305.536C305.922 160.88 306.235 160.541 306.235 160.122C306.235 159.704 305.922 159.365 305.536 159.365H279.464C279.078 159.365 278.765 159.704 278.765 160.122C278.765 160.541 279.078 160.88 279.464 160.88ZM279.464 173.56H305.536C305.922 173.56 306.235 173.22 306.235 172.802C306.235 172.384 305.922 172.044 305.536 172.044H279.464C279.078 172.044 278.765 172.384 278.765 172.802C278.765 173.22 279.078 173.56 279.464 173.56ZM281.7 154.54H303.3C303.685 154.54 303.998 154.201 303.998 153.782C303.998 153.364 303.685 153.025 303.3 153.025H281.7C281.315 153.025 281.002 153.364 281.002 153.782C281.002 154.201 281.315 154.54 281.7 154.54Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 7,
    width: 71.1117,
    height: 44,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 16.0405C251.89 16.0413 252.835 15.0974 252.836 13.9324C252.836 12.7673 251.893 11.8221 250.728 11.8213C249.563 11.8205 248.618 12.7643 248.617 13.9294C248.618 15.0938 249.561 16.0379 250.725 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 22.0688C251.89 22.0696 252.835 21.1258 252.836 19.9607C252.836 18.7956 251.893 17.8504 250.728 17.8496C249.563 17.8488 248.618 18.7926 248.617 19.9577C248.618 21.1221 249.561 22.0662 250.725 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 28.0961C251.89 28.0969 252.835 27.1531 252.836 25.988C252.836 24.8229 251.893 23.8778 250.728 23.877C249.563 23.8761 248.618 24.82 248.617 25.9851C248.618 27.1494 249.561 28.0936 250.725 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 34.1235C251.89 34.1243 252.835 33.1805 252.836 32.0154C252.836 30.8503 251.893 29.9051 250.728 29.9043C249.563 29.9035 248.618 30.8473 248.617 32.0124C248.618 33.1768 249.561 34.1209 250.725 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 40.1508C251.89 40.1516 252.835 39.2078 252.836 38.0427C252.836 36.8776 251.893 35.9325 250.728 35.9316C249.563 35.9308 248.618 36.8747 248.617 38.0398C248.618 39.2041 249.561 40.1483 250.725 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.725 46.1782C251.89 46.179 252.835 45.2351 252.836 44.07C252.836 42.905 251.893 41.9598 250.728 41.959C249.563 41.9582 248.618 42.902 248.617 44.0671C248.618 45.2315 249.561 46.1756 250.725 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 16.0405C257.913 16.0413 258.858 15.0974 258.859 13.9324C258.86 12.7673 257.916 11.8221 256.751 11.8213C255.586 11.8205 254.641 12.7643 254.641 13.9294C254.642 15.0938 255.584 16.0379 256.748 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 22.0688C257.913 22.0696 258.858 21.1258 258.859 19.9607C258.86 18.7956 257.916 17.8504 256.751 17.8496C255.586 17.8488 254.641 18.7926 254.641 19.9577C254.642 21.1221 255.584 22.0662 256.748 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 28.0961C257.913 28.0969 258.858 27.1531 258.859 25.988C258.86 24.8229 257.916 23.8778 256.751 23.877C255.586 23.8761 254.641 24.82 254.641 25.9851C254.642 27.1494 255.584 28.0936 256.748 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 34.1235C257.913 34.1243 258.858 33.1805 258.859 32.0154C258.86 30.8503 257.916 29.9051 256.751 29.9043C255.586 29.9035 254.641 30.8473 254.641 32.0124C254.642 33.1768 255.584 34.1209 256.748 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 40.1508C257.913 40.1516 258.858 39.2078 258.859 38.0427C258.86 36.8776 257.916 35.9325 256.751 35.9316C255.586 35.9308 254.641 36.8747 254.641 38.0398C254.642 39.2041 255.584 40.1483 256.748 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.748 46.1782C257.913 46.179 258.858 45.2351 258.859 44.07C258.86 42.905 257.916 41.9598 256.751 41.959C255.586 41.9582 254.641 42.902 254.641 44.0671C254.642 45.2315 255.584 46.1756 256.748 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 16.0405C263.937 16.0413 264.882 15.0974 264.883 13.9324C264.883 12.7673 263.94 11.8221 262.775 11.8213C261.61 11.8205 260.665 12.7643 260.664 13.9294C260.665 15.0938 261.608 16.0379 262.772 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 22.0688C263.937 22.0696 264.882 21.1258 264.883 19.9607C264.883 18.7956 263.94 17.8504 262.775 17.8496C261.61 17.8488 260.665 18.7926 260.664 19.9577C260.665 21.1221 261.608 22.0662 262.772 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 28.0961C263.937 28.0969 264.882 27.1531 264.883 25.988C264.883 24.8229 263.94 23.8778 262.775 23.877C261.61 23.8761 260.665 24.82 260.664 25.9851C260.665 27.1494 261.608 28.0936 262.772 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 34.1235C263.937 34.1243 264.882 33.1805 264.883 32.0154C264.883 30.8503 263.94 29.9051 262.775 29.9043C261.61 29.9035 260.665 30.8473 260.664 32.0124C260.665 33.1768 261.608 34.1209 262.772 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 40.1508C263.937 40.1516 264.882 39.2078 264.883 38.0427C264.883 36.8776 263.94 35.9325 262.775 35.9316C261.61 35.9308 260.665 36.8747 260.664 38.0398C260.665 39.2041 261.608 40.1483 262.772 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.772 46.1782C263.937 46.179 264.882 45.2351 264.883 44.07C264.883 42.905 263.94 41.9598 262.775 41.959C261.61 41.9582 260.665 42.902 260.664 44.0671C260.665 45.2315 261.608 46.1756 262.772 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 16.0405C269.968 16.0413 270.913 15.0974 270.914 13.9324C270.915 12.7673 269.971 11.8221 268.806 11.8213C267.641 11.8205 266.696 12.7643 266.695 13.9294C266.696 15.0938 267.639 16.0379 268.803 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 22.0688C269.968 22.0696 270.913 21.1258 270.914 19.9607C270.915 18.7956 269.971 17.8504 268.806 17.8496C267.641 17.8488 266.696 18.7926 266.695 19.9577C266.696 21.1221 267.639 22.0662 268.803 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 28.0961C269.968 28.0969 270.913 27.1531 270.914 25.988C270.915 24.8229 269.971 23.8778 268.806 23.877C267.641 23.8761 266.696 24.82 266.695 25.9851C266.696 27.1494 267.639 28.0936 268.803 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 34.1235C269.968 34.1243 270.913 33.1805 270.914 32.0154C270.915 30.8503 269.971 29.9051 268.806 29.9043C267.641 29.9035 266.696 30.8473 266.695 32.0124C266.696 33.1768 267.639 34.1209 268.803 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 40.1508C269.968 40.1516 270.913 39.2078 270.914 38.0427C270.915 36.8776 269.971 35.9325 268.806 35.9316C267.641 35.9308 266.696 36.8747 266.695 38.0398C266.696 39.2041 267.639 40.1483 268.803 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.803 46.1782C269.968 46.179 270.913 45.2351 270.914 44.07C270.915 42.905 269.971 41.9598 268.806 41.959C267.641 41.9582 266.696 42.902 266.695 44.0671C266.696 45.2315 267.639 46.1756 268.803 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 16.0405C275.999 16.0413 276.944 15.0974 276.945 13.9324C276.946 12.7673 276.002 11.8221 274.837 11.8213C273.672 11.8205 272.727 12.7643 272.727 13.9294C272.727 15.0938 273.67 16.0379 274.834 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 22.0688C275.999 22.0696 276.944 21.1258 276.945 19.9607C276.946 18.7956 276.002 17.8504 274.837 17.8496C273.672 17.8488 272.727 18.7926 272.727 19.9577C272.727 21.1221 273.67 22.0662 274.834 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 28.0961C275.999 28.0969 276.944 27.1531 276.945 25.988C276.946 24.8229 276.002 23.8778 274.837 23.877C273.672 23.8761 272.727 24.82 272.727 25.9851C272.727 27.1494 273.67 28.0936 274.834 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 34.1235C275.999 34.1243 276.944 33.1805 276.945 32.0154C276.946 30.8503 276.002 29.9051 274.837 29.9043C273.672 29.9035 272.727 30.8473 272.727 32.0124C272.727 33.1768 273.67 34.1209 274.834 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 40.1508C275.999 40.1516 276.944 39.2078 276.945 38.0427C276.946 36.8776 276.002 35.9325 274.837 35.9316C273.672 35.9308 272.727 36.8747 272.727 38.0398C272.727 39.2041 273.67 40.1483 274.834 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.834 46.1782C275.999 46.179 276.944 45.2351 276.945 44.07C276.946 42.905 276.002 41.9598 274.837 41.959C273.672 41.9582 272.727 42.902 272.727 44.0671C272.727 45.2315 273.67 46.1756 274.834 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 16.0405C282.023 16.0413 282.968 15.0974 282.969 13.9324C282.969 12.7673 282.026 11.8221 280.861 11.8213C279.696 11.8205 278.751 12.7643 278.75 13.9294C278.751 15.0938 279.694 16.0379 280.858 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 22.0688C282.023 22.0696 282.968 21.1258 282.969 19.9607C282.969 18.7956 282.026 17.8504 280.861 17.8496C279.696 17.8488 278.751 18.7926 278.75 19.9577C278.751 21.1221 279.694 22.0662 280.858 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 28.0961C282.023 28.0969 282.968 27.1531 282.969 25.988C282.969 24.8229 282.026 23.8778 280.861 23.877C279.696 23.8761 278.751 24.82 278.75 25.9851C278.751 27.1494 279.694 28.0936 280.858 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 34.1235C282.023 34.1243 282.968 33.1805 282.969 32.0154C282.969 30.8503 282.026 29.9051 280.861 29.9043C279.696 29.9035 278.751 30.8473 278.75 32.0124C278.751 33.1768 279.694 34.1209 280.858 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 40.1508C282.023 40.1516 282.968 39.2078 282.969 38.0427C282.969 36.8776 282.026 35.9325 280.861 35.9316C279.696 35.9308 278.751 36.8747 278.75 38.0398C278.751 39.2041 279.694 40.1483 280.858 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.858 46.1782C282.023 46.179 282.968 45.2351 282.969 44.07C282.969 42.905 282.026 41.9598 280.861 41.959C279.696 41.9582 278.751 42.902 278.75 44.0671C278.751 45.2315 279.694 46.1756 280.858 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 16.0405C288.046 16.0413 288.991 15.0974 288.992 13.9324C288.993 12.7673 288.049 11.8221 286.884 11.8213C285.719 11.8205 284.774 12.7643 284.773 13.9294C284.774 15.0938 285.717 16.0379 286.881 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 22.0688C288.046 22.0696 288.991 21.1258 288.992 19.9607C288.993 18.7956 288.049 17.8504 286.884 17.8496C285.719 17.8488 284.774 18.7926 284.773 19.9577C284.774 21.1221 285.717 22.0662 286.881 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 28.0961C288.046 28.0969 288.991 27.1531 288.992 25.988C288.993 24.8229 288.049 23.8778 286.884 23.877C285.719 23.8761 284.774 24.82 284.773 25.9851C284.774 27.1494 285.717 28.0936 286.881 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 34.1235C288.046 34.1243 288.991 33.1805 288.992 32.0154C288.993 30.8503 288.049 29.9051 286.884 29.9043C285.719 29.9035 284.774 30.8473 284.773 32.0124C284.774 33.1768 285.717 34.1209 286.881 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 40.1508C288.046 40.1516 288.991 39.2078 288.992 38.0427C288.993 36.8776 288.049 35.9325 286.884 35.9316C285.719 35.9308 284.774 36.8747 284.773 38.0398C284.774 39.2041 285.717 40.1483 286.881 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.881 46.1782C288.046 46.179 288.991 45.2351 288.992 44.07C288.993 42.905 288.049 41.9598 286.884 41.959C285.719 41.9582 284.774 42.902 284.773 44.0671C284.774 45.2315 285.717 46.1756 286.881 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 16.0405C294.07 16.0413 295.015 15.0974 295.015 13.9324C295.016 12.7673 294.073 11.8221 292.908 11.8213C291.743 11.8205 290.798 12.7643 290.797 13.9294C290.798 15.0938 291.74 16.0379 292.905 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 22.0688C294.07 22.0696 295.015 21.1258 295.015 19.9607C295.016 18.7956 294.073 17.8504 292.908 17.8496C291.743 17.8488 290.798 18.7926 290.797 19.9577C290.798 21.1221 291.74 22.0662 292.905 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 28.0961C294.07 28.0969 295.015 27.1531 295.015 25.988C295.016 24.8229 294.073 23.8778 292.908 23.877C291.743 23.8761 290.798 24.82 290.797 25.9851C290.798 27.1494 291.74 28.0936 292.905 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 34.1235C294.07 34.1243 295.015 33.1805 295.015 32.0154C295.016 30.8503 294.073 29.9051 292.908 29.9043C291.743 29.9035 290.798 30.8473 290.797 32.0124C290.798 33.1768 291.74 34.1209 292.905 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 40.1508C294.07 40.1516 295.015 39.2078 295.015 38.0427C295.016 36.8776 294.073 35.9325 292.908 35.9316C291.743 35.9308 290.798 36.8747 290.797 38.0398C290.798 39.2041 291.74 40.1483 292.905 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.905 46.1782C294.07 46.179 295.015 45.2351 295.015 44.07C295.016 42.905 294.073 41.9598 292.908 41.959C291.743 41.9582 290.798 42.902 290.797 44.0671C290.798 45.2315 291.74 46.1756 292.905 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 16.0405C300.093 16.0413 301.038 15.0974 301.039 13.9324C301.04 12.7673 300.096 11.8221 298.931 11.8213C297.766 11.8205 296.821 12.7643 296.82 13.9294C296.821 15.0938 297.764 16.0379 298.928 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 22.0688C300.093 22.0696 301.038 21.1258 301.039 19.9607C301.04 18.7956 300.096 17.8504 298.931 17.8496C297.766 17.8488 296.821 18.7926 296.82 19.9577C296.821 21.1221 297.764 22.0662 298.928 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 28.0961C300.093 28.0969 301.038 27.1531 301.039 25.988C301.04 24.8229 300.096 23.8778 298.931 23.877C297.766 23.8761 296.821 24.82 296.82 25.9851C296.821 27.1494 297.764 28.0936 298.928 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 34.1235C300.093 34.1243 301.038 33.1805 301.039 32.0154C301.04 30.8503 300.096 29.9051 298.931 29.9043C297.766 29.9035 296.821 30.8473 296.82 32.0124C296.821 33.1768 297.764 34.1209 298.928 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 40.1508C300.093 40.1516 301.038 39.2078 301.039 38.0427C301.04 36.8776 300.096 35.9325 298.931 35.9316C297.766 35.9308 296.821 36.8747 296.82 38.0398C296.821 39.2041 297.764 40.1483 298.928 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.928 46.1782C300.093 46.179 301.038 45.2351 301.039 44.07C301.04 42.905 300.096 41.9598 298.931 41.959C297.766 41.9582 296.821 42.902 296.82 44.0671C296.821 45.2315 297.764 46.1756 298.928 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 16.0405C306.124 16.0413 307.069 15.0974 307.07 13.9324C307.071 12.7673 306.127 11.8221 304.962 11.8213C303.797 11.8205 302.852 12.7643 302.852 13.9294C302.852 15.0938 303.795 16.0379 304.959 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 22.0688C306.124 22.0696 307.069 21.1258 307.07 19.9607C307.071 18.7956 306.127 17.8504 304.962 17.8496C303.797 17.8488 302.852 18.7926 302.852 19.9577C302.852 21.1221 303.795 22.0662 304.959 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 28.0961C306.124 28.0969 307.069 27.1531 307.07 25.988C307.071 24.8229 306.127 23.8778 304.962 23.877C303.797 23.8761 302.852 24.82 302.852 25.9851C302.852 27.1494 303.795 28.0936 304.959 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 34.1235C306.124 34.1243 307.069 33.1805 307.07 32.0154C307.071 30.8503 306.127 29.9051 304.962 29.9043C303.797 29.9035 302.852 30.8473 302.852 32.0124C302.852 33.1768 303.795 34.1209 304.959 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 40.1508C306.124 40.1516 307.069 39.2078 307.07 38.0427C307.071 36.8776 306.127 35.9325 304.962 35.9316C303.797 35.9308 302.852 36.8747 302.852 38.0398C302.852 39.2041 303.795 40.1483 304.959 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 46.1782C306.124 46.179 307.069 45.2351 307.07 44.07C307.071 42.905 306.127 41.9598 304.962 41.959C303.797 41.9582 302.852 42.902 302.852 44.0671C302.852 45.2315 303.795 46.1756 304.959 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 16.0405C312.155 16.0413 313.1 15.0974 313.101 13.9324C313.102 12.7673 312.158 11.8221 310.994 11.8213C309.829 11.8205 308.884 12.7643 308.883 13.9294C308.884 15.0938 309.826 16.0379 310.991 16.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 22.0688C312.155 22.0696 313.1 21.1258 313.101 19.9607C313.102 18.7956 312.158 17.8504 310.994 17.8496C309.829 17.8488 308.884 18.7926 308.883 19.9577C308.884 21.1221 309.826 22.0662 310.991 22.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 28.0961C312.155 28.0969 313.1 27.1531 313.101 25.988C313.102 24.8229 312.158 23.8778 310.994 23.877C309.829 23.8761 308.884 24.82 308.883 25.9851C308.884 27.1494 309.826 28.0936 310.991 28.0961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 34.1235C312.155 34.1243 313.1 33.1805 313.101 32.0154C313.102 30.8503 312.158 29.9051 310.994 29.9043C309.829 29.9035 308.884 30.8473 308.883 32.0124C308.884 33.1768 309.826 34.1209 310.991 34.1235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 40.1508C312.155 40.1516 313.1 39.2078 313.101 38.0427C313.102 36.8776 312.158 35.9325 310.994 35.9316C309.829 35.9308 308.884 36.8747 308.883 38.0398C308.884 39.2041 309.826 40.1483 310.991 40.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.991 46.1782C312.155 46.179 313.1 45.2351 313.101 44.07C313.102 42.905 312.158 41.9598 310.994 41.959C309.829 41.9582 308.884 42.902 308.883 44.0671C308.884 45.2315 309.826 46.1756 310.991 46.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.848 252C232.498 252 224.047 243.548 224.047 233.196V218.218H234.425V232.26C234.425 236.913 238.196 240.712 242.848 240.712C247.501 240.712 251.299 236.913 251.299 232.26V218.218H261.677V233.196C261.677 243.548 253.226 252 242.848 252ZM224.047 217.502V213.923C224.047 213.51 224.377 213.18 224.79 213.18H233.682C234.095 213.18 234.425 213.51 234.425 213.923V217.502H224.047ZM251.299 217.502V213.923V213.896V213.868V213.84V213.813L251.327 213.785V213.758V213.73V213.703L251.355 213.675V213.648V213.62H251.382V213.593V213.565L251.41 213.538V213.51H251.437V213.483L251.465 213.455L251.492 213.427L251.52 213.4V213.372H251.547V213.345H251.575L251.602 213.317L251.63 213.29H251.657L251.685 213.262H251.712L251.74 213.235H251.767H251.795V213.207H251.822H251.85H251.878V213.18H251.905H251.933H251.96H251.988H252.015H252.043H260.934C261.347 213.18 261.677 213.51 261.677 213.923V217.502H251.299Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.189 209.243C228.776 209.243 228.445 208.912 228.445 208.499V205.939C228.445 205.526 228.776 205.195 229.189 205.195C229.601 205.195 229.932 205.526 229.932 205.939V208.499C229.932 208.912 229.601 209.243 229.189 209.243Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.128 210.785C232.963 210.785 232.77 210.73 232.605 210.592C232.33 210.289 232.33 209.821 232.605 209.546L234.367 207.811C234.642 207.508 235.11 207.508 235.385 207.811C235.688 208.086 235.688 208.555 235.385 208.83L233.651 210.592C233.513 210.73 233.321 210.785 233.128 210.785Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.336 210.785C225.143 210.785 224.951 210.73 224.813 210.592L223.079 208.83C222.776 208.555 222.776 208.086 223.079 207.811C223.354 207.508 223.822 207.508 224.097 207.811L225.859 209.546C226.134 209.821 226.134 210.289 225.859 210.592C225.721 210.73 225.529 210.785 225.336 210.785Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.517 209.243C256.104 209.243 255.773 208.912 255.773 208.499V205.939C255.773 205.526 256.104 205.195 256.517 205.195C256.93 205.195 257.26 205.526 257.26 205.939V208.499C257.26 208.912 256.93 209.243 256.517 209.243Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.378 210.785C260.185 210.785 259.993 210.73 259.855 210.592C259.58 210.289 259.58 209.821 259.855 209.546L261.589 207.811C261.892 207.508 262.36 207.508 262.635 207.811C262.91 208.086 262.91 208.555 262.635 208.83L260.901 210.592C260.763 210.73 260.571 210.785 260.378 210.785Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.585 210.785C252.392 210.785 252.2 210.73 252.062 210.592L250.3 208.83C250.025 208.555 250.025 208.086 250.3 207.811C250.603 207.508 251.071 207.508 251.346 207.811L253.081 209.546C253.383 209.821 253.383 210.289 253.081 210.592C252.943 210.73 252.75 210.785 252.585 210.785Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.389 225.569C240.307 225.569 240.224 225.569 240.169 225.541C239.811 225.431 239.591 225.073 239.646 224.716C239.756 223.945 240.004 222.843 240.279 221.659C240.582 220.31 240.912 218.824 241.05 217.75H238.077C237.829 217.75 237.581 217.612 237.444 217.364C237.306 217.144 237.306 216.841 237.471 216.621L244.629 205.525C244.629 205.498 244.629 205.498 244.629 205.498C244.739 205.195 245.041 204.975 245.372 205.002C245.757 205.03 246.06 205.36 246.06 205.746C246.06 205.801 246.06 205.856 246.032 205.911C245.922 206.682 245.702 207.728 245.427 208.829C245.124 210.233 244.766 211.775 244.629 212.877L247.602 212.794C247.849 212.794 248.125 212.932 248.262 213.179C248.372 213.427 248.372 213.703 248.235 213.923L241.105 225.018L241.05 225.156C240.912 225.404 240.665 225.569 240.389 225.569Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 266.5C191.5 268.476 189.93 270.083 188 270.083C186.07 270.083 184.5 268.476 184.5 266.5C184.5 264.524 186.07 262.917 188 262.917C189.93 262.917 191.5 264.524 191.5 266.5ZM209 246.194V286.806C209 287.465 208.478 288 207.833 288H168.167C167.522 288 167 287.465 167 286.806V246.194C167 245.535 167.522 245 168.167 245H207.833C208.478 245 209 245.535 209 246.194ZM171.667 250.972C171.667 251.632 172.189 252.167 172.833 252.167C173.477 252.167 174 251.632 174 250.972C174 250.313 173.477 249.778 172.833 249.778C172.189 249.778 171.667 250.313 171.667 250.972ZM174 282.028C174 281.368 173.477 280.833 172.833 280.833C172.189 280.833 171.667 281.368 171.667 282.028C171.667 282.687 172.189 283.222 172.833 283.222C173.477 283.222 174 282.687 174 282.028ZM204.333 282.028C204.333 281.368 203.811 280.833 203.167 280.833C202.523 280.833 202 281.368 202 282.028C202 282.687 202.523 283.222 203.167 283.222C203.811 283.222 204.333 282.687 204.333 282.028ZM204.333 266.5C204.333 257.279 197.007 249.778 188 249.778C178.993 249.778 171.667 257.279 171.667 266.5C171.667 275.721 178.993 283.222 188 283.222C197.007 283.222 204.333 275.721 204.333 266.5ZM204.333 250.972C204.333 250.313 203.811 249.778 203.167 249.778C202.523 249.778 202 250.313 202 250.972C202 251.632 202.523 252.167 203.167 252.167C203.811 252.167 204.333 251.632 204.333 250.972ZM182.21 266.935C182.199 266.789 182.167 266.649 182.167 266.5C182.167 266.074 182.214 265.659 182.297 265.258C181.762 263.418 180.142 262.15 178.25 262.15C175.907 262.15 174.002 264.099 174 266.496V266.501C174 268.245 174.321 269.91 174.881 271.458C175.192 270.486 175.697 269.566 176.451 268.795C178.005 267.201 180.154 266.568 182.21 266.935ZM191.794 262.001C192.207 262.366 192.579 262.775 192.879 263.245C194.53 264.166 196.557 263.891 197.899 262.519C199.528 260.851 199.548 258.162 197.975 256.459C196.804 255.24 195.417 254.243 193.885 253.513C194.328 254.419 194.585 255.438 194.585 256.519C194.583 258.768 193.501 260.773 191.794 262.001ZM184.206 270.999C183.793 270.634 183.421 270.225 183.121 269.756C181.47 268.835 179.441 269.109 178.101 270.482C176.473 272.149 176.453 274.834 178.021 276.537C179.194 277.759 180.582 278.757 182.117 279.49C181.673 278.583 181.416 277.564 181.416 276.483C181.416 274.232 182.499 272.227 184.206 270.999ZM187.575 260.572C187.718 260.561 187.855 260.528 188 260.528C188.417 260.528 188.821 260.577 189.214 260.662C191.011 260.113 192.25 258.455 192.25 256.518C192.25 254.118 190.344 252.167 188 252.167C186.297 252.167 184.67 252.495 183.158 253.068C184.108 253.387 185.007 253.905 185.761 254.676C187.315 256.267 187.933 258.467 187.575 260.572ZM183.606 262.616C183.963 262.193 184.362 261.812 184.821 261.505C185.72 259.815 185.452 257.738 184.111 256.365C182.484 254.699 179.861 254.679 178.198 256.284C177.004 257.484 176.029 258.906 175.315 260.476C176.2 260.023 177.195 259.761 178.251 259.761C180.448 259.76 182.406 260.868 183.606 262.616ZM188.425 272.428C188.282 272.439 188.146 272.472 188 272.472C187.583 272.472 187.177 272.423 186.785 272.338C184.989 272.887 183.75 274.546 183.75 276.482C183.75 278.882 185.655 280.833 187.999 280.833C189.702 280.833 191.33 280.505 192.842 279.932C191.892 279.613 190.993 279.095 190.239 278.324C188.685 276.733 188.066 274.533 188.425 272.428ZM193.79 266.065C193.801 266.211 193.833 266.351 193.833 266.5C193.833 266.926 193.785 267.342 193.703 267.743C194.238 269.583 195.857 270.851 197.75 270.851C200.094 270.851 202 268.9 202 266.5C202 264.756 201.679 263.09 201.119 261.543C200.808 262.515 200.302 263.436 199.549 264.208C197.996 265.799 195.846 266.432 193.79 266.065ZM192.395 270.384C192.038 270.807 191.639 271.188 191.179 271.495C190.28 273.185 190.548 275.261 191.888 276.635C193.517 278.302 196.143 278.321 197.807 276.712C198.998 275.513 199.972 274.093 200.686 272.524C199.801 272.977 198.806 273.24 197.75 273.24C195.552 273.24 193.594 272.132 192.395 270.384Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.2 209.057V224.548C162.953 226.906 156.903 217.452 156.088 217.356C154.89 217.213 152.349 219.038 152.349 220.171V236H151V219.497C151 216.713 155.752 216.378 156.877 215.591C158.13 214.711 160.029 210.933 162.223 209.815C163.93 208.943 165.349 208.932 167.2 209.057Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.117 209.034C197.798 208.537 199.709 213.651 202.104 215.385C203.267 216.225 205.707 216.364 206.676 217.307C206.837 217.465 208.237 219.995 208.237 220.157V236H206.863V220.157C206.863 219.682 203.008 216.56 202.111 217.163C200.703 220.912 197.321 224.343 193.117 224.538V209.034Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.883 223.04L186.322 222.761C184.828 221.831 186.072 211.879 185.665 209.641L189.883 209V223.04Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.438 209L174.653 209.745C174.829 213.911 174.739 218.151 174.692 222.335L170.438 223.04V209Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32 211.16H178V221.96H182.32V211.16Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.217 217.784V246.97C130.962 249.15 127.66 248.837 124.854 249.623V263.184H123.66V249.623H114.7V263.184C113.3 263.261 113.643 263.387 113.503 262.311C113.059 258.888 114.25 252.895 113.519 250.035C113.353 249.391 111.613 249.382 111.698 248.171L111.711 219.552C118.886 220.505 126.368 220.193 133.22 217.787L133.217 217.784Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.021 213.146C115.519 212.891 133.203 212.636 133.22 215.511C127.491 219.619 115.974 219.158 109.094 217.68C100.645 215.861 109.126 213.542 113.021 213.149V213.146Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.392 218.373V248.402C106.882 248.248 105 247.215 105 246.929V217.784L107.392 218.373Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.735 248.819C110.039 249.057 108.344 248.559 108.344 247.935V218.801C109.04 218.563 110.735 219.061 110.735 219.685V248.822V248.819Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.997 307.522L199.659 308.661L191.797 304.589V304.41H198.597C199.096 304.413 199.589 304.525 200.04 304.74C200.491 304.954 200.889 305.265 201.206 305.651C201.658 306.177 201.934 306.831 201.997 307.522Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.628 306.051H190.951C191.169 306.04 191.375 305.945 191.525 305.787C191.676 305.629 191.759 305.419 191.759 305.201V299.7C191.759 299.249 191.58 298.817 191.261 298.498C190.942 298.179 190.51 298 190.059 298H179.825C179.374 298 178.942 298.179 178.623 298.498C178.304 298.817 178.125 299.249 178.125 299.7V304.444L181.261 306.068L192.753 312.019L197.59 309.681L190.628 306.051ZM179.757 304.41V299.7L179.825 299.658L190.161 299.7V304.427L179.757 304.41Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.128 304.41V304.427L178.094 304.41H178.128Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.805 335.959L199.784 322.926L200.557 317.8L172.031 331.58L172.805 335.959Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.695 312.988C190.695 312.988 174.468 304.538 174.392 304.41H171.34C170.832 304.405 170.33 304.514 169.869 304.729C169.409 304.944 169.003 305.259 168.68 305.652C168.351 306.04 168.118 306.5 168 306.995L184.932 315.777L190.695 312.988Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.566 340.931H179.758V340.923H186.558L186.566 340.931Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 332.354L179.052 334.989L187.381 339.282H183.387L176.986 335.975L173.102 337.837L173.153 338.109C173.29 338.907 173.708 339.63 174.332 340.148C174.955 340.665 175.743 340.943 176.553 340.931H178.108V343.907C178.108 344.358 178.287 344.79 178.606 345.109C178.925 345.428 179.357 345.607 179.808 345.607H190.101C190.552 345.607 190.985 345.428 191.304 345.109C191.622 344.79 191.801 344.358 191.801 343.907V340.931H194.105C194.768 340.937 195.418 340.748 195.976 340.389C196.533 340.029 196.973 339.514 197.241 338.908L184.5 332.354ZM190.101 343.966L179.757 343.907V340.923H190.152L190.101 343.966Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.699 330.058L199.439 325.119L194.109 327.704L198.699 330.058Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.555 331.351L197.639 337.064L198.412 331.971L192.046 328.698L186.555 331.351Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.706 329.71L200.886 315.607L201.779 309.664L170.805 324.635L171.706 329.71Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.877 316.771L168.07 309.103L169.073 314.79L177.735 319.253L182.877 316.771Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.469 317.052L170.472 322.756L175.665 320.248L169.469 317.052Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.882 261.397C271.189 261.022 266.27 265.332 265.894 271.026C265.519 276.719 269.829 281.639 275.521 282.015C281.214 282.391 286.133 278.08 286.509 272.387C286.885 266.693 282.575 261.773 276.882 261.397ZM276.601 265.663C273.263 265.443 270.38 267.97 270.16 271.308C269.939 274.645 272.466 277.529 275.803 277.749C279.14 277.97 282.024 275.443 282.244 272.105C282.464 268.767 279.937 265.883 276.601 265.663Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.234 262.977C311.926 263.353 316.236 268.273 315.86 273.966C315.485 279.66 310.565 283.971 304.873 283.595C299.18 283.219 294.87 278.299 295.246 272.606C295.622 266.913 300.541 262.602 306.234 262.977ZM305.952 267.243C309.289 267.463 311.816 270.347 311.595 273.685C311.375 277.023 308.491 279.55 305.154 279.329C301.817 279.109 299.291 276.225 299.511 272.887C299.731 269.55 302.615 267.023 305.952 267.243Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.626 249.698L308.363 217.061C310.133 206.466 306.294 205.142 306.294 205.142L288.906 246.838C286.011 251.013 282.836 257.199 278.503 260.227C281.73 260.87 284.445 262.827 286.116 265.486C286.21 258.296 286.536 253.789 296.752 252.354L297.626 249.698ZM291.725 247.786C291.79 246.805 292.637 246.062 293.618 246.127C294.599 246.192 295.342 247.039 295.277 248.02C295.212 249.001 294.365 249.744 293.384 249.679C292.403 249.615 291.66 248.767 291.725 247.786Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.668 234.242L284.465 203.345C284.465 203.345 280.485 204.153 280.848 214.888L286.957 247.277C287.208 246.893 287.452 246.524 287.692 246.176L292.668 234.242Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.739 261.607C301.803 258.99 300.208 255.088 298.496 251.467L297.795 253.598L296.947 253.717C295.948 253.858 294.83 254.048 293.733 254.353C297.775 257.484 297.27 261.071 296.596 265.753C298.591 263.383 301.501 261.829 304.739 261.607Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 278,
    width: 153,
    height: 58.4971,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 281.644,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 281.644,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 284.625,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 284.625,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 281.644,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 281.644,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 281.644,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 281.644,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 284.625,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 284.625,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 284.625,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 284.625,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 309.467,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 309.467,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 315.428,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 315.428,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 321.391,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 321.391,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 312.447,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 312.447,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 318.409,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 318.409,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 324.371,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 324.371,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 309.467,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 309.467,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 309.467,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 309.467,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 309.467,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 315.428,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 315.428,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 315.428,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 315.428,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 315.428,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 321.391,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 321.391,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 321.391,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 321.391,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 321.391,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 312.447,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 312.447,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 312.447,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 312.447,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 312.447,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 318.409,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 318.409,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 318.409,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 318.409,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 318.409,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 324.371,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 324.371,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 324.371,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 324.371,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 324.371,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.64062,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9219,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.633,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 289.262,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 289.262,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 295.224,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 295.224,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 301.186,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 301.186,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 292.243,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 292.243,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 298.205,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 298.205,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2812,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8516,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5625,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.281,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 304.167,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 304.167,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9219,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0625,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7812,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 289.262,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 289.262,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 289.262,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 289.262,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 289.262,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 295.224,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 295.224,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 295.224,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 295.224,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 295.224,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 301.186,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 301.186,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 301.186,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 301.186,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 301.186,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 292.243,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 292.243,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 292.243,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 292.243,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 292.243,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 298.205,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 298.205,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 298.205,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 298.205,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 298.205,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5625,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7031,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4219,
    y: 304.167,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 304.167,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 304.167,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.133,
    y: 304.167,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 304.167,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4922,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2109,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0625,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.922,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.781,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 329.009,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 329.009,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9922,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8516,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7031,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.562,
    y: 331.989,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.422,
    y: 331.989,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7812,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4922,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.352,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.203,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.062,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 329.009,
    width: 1.32467,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 329.009,
    width: 1.32468,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 329.009,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 329.009,
    width: 1.32466,
    height: 1.32488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4219,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1328,
    y: 331.989,
    width: 1.32467,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.992,
    y: 331.989,
    width: 1.32468,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.852,
    y: 331.989,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.711,
    y: 331.989,
    width: 1.32466,
    height: 1.32491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 279.987H153.517",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 327.353H153.517",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97656 307.479H154.181",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 287.605H153.517",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 334.971H153.517",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.716 334.003C258.519 336.087 256.673 336.417 256.556 336.852C255.971 339.015 256.033 342.557 255.929 344.868C254.515 344.964 254.882 345.063 254.746 343.971C254.444 341.531 254.346 338.877 254.148 336.417H249.387L247.898 345.482L246.667 336.407L241.646 336.417L240.749 344.875C239.303 345.3 239.992 343.526 239.891 342.735C239.618 340.641 239.215 338.537 239.27 336.414H234.509L233.021 345.478L232.13 336.414H226.771C226.573 338.874 226.475 341.528 226.173 343.968C226.037 345.06 226.404 344.961 224.99 344.865C224.886 342.554 224.948 339.012 224.363 336.849C224.246 336.414 222.397 336.087 223.203 334H257.713L257.716 334.003Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.744 288V333.927H221V288H259.744ZM250.353 292.176H230.981C231.052 293.46 230.478 295.779 231.943 296.268L250.097 295.792L250.353 292.173V292.176ZM255.637 327.366H224.524V330.347H255.637V327.366Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.351 344.797H306.295V298.561C303.972 296.804 296.217 296.727 293.36 297.266C291.732 297.571 290.883 299.398 290.97 300.91C293.019 301.309 298.673 301.626 299.342 303.898C299.804 305.458 296.927 312.92 295.602 313.591C293.689 314.558 286.886 314.961 285.163 313.708C284.808 313.448 282.242 307.094 282.104 306.272C281.12 300.368 287.394 302.514 289.596 300.973C290.182 300.565 289.914 296.769 292.831 296.224C294.592 295.896 302.555 295.95 304.413 296.242C305.19 296.364 307.351 297.463 307.351 298.039V344.797Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.809 348.077L288.921 347.388C277.711 346.957 283.152 341.523 284.555 334.751C288.512 335.609 292.404 334.519 296.197 335.04C296.551 337.747 299.918 342.123 299.089 344.693C298.15 347.603 292.709 346.597 290.866 348.077V357.236H289.811V348.077H289.809Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.345 319.92V327.937C292.697 328.264 288.94 329.093 285.344 327.937V320.454C289.072 320.641 292.689 321.003 296.345 319.92Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.34 329.967L296.345 332.935C292.507 333.136 289.19 333.68 285.344 332.935L285.352 329.97C288.813 331.265 292.779 330.452 296.34 329.97V329.967Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.344 318.963V316.172C289.088 316.873 292.732 317.138 296.345 315.614L296.268 318.308C295.89 318.39 295.232 318.96 295.04 318.96H285.344V318.963Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9312 364.424L41.6224 348.54V348.336C41.6222 347.758 41.5121 347.185 41.2985 346.653C41.0849 346.12 40.7721 345.638 40.3785 345.234C39.9849 344.83 39.5184 344.513 39.0065 344.301C38.4946 344.09 37.9476 343.988 37.3976 344.001C36.8476 344.015 36.3057 344.144 35.8038 344.381C35.302 344.617 34.8502 344.957 34.4752 345.38C34.1001 345.803 33.8093 346.3 33.6198 346.843C33.4303 347.385 33.3459 347.962 33.3717 348.54L34.0629 364.424H40.9312Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 396.581H19.4698V407.01H15.125V396.581Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9453 396.581H27.2901V407.01H22.9453V396.581Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.875 373.115H7.125C6.50368 373.115 6 373.634 6 374.274V378.909C6 379.549 6.50368 380.068 7.125 380.068H67.875C68.4963 380.068 69 379.549 69 378.909V374.274C69 373.634 68.4963 373.115 67.875 373.115Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7534 369.928C50.7526 369.621 50.636 369.327 50.4291 369.11C50.2221 368.893 49.9418 368.77 49.6491 368.77H25.3543C25.0617 368.77 24.7813 368.893 24.5744 369.11C24.3675 369.327 24.2508 369.621 24.25 369.928V372.246H50.7534V369.928Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5805 366.379C48.5797 366.091 48.4626 365.816 48.2551 365.612C48.0475 365.409 47.7661 365.294 47.4726 365.293H27.5298C27.2362 365.294 26.9549 365.409 26.7473 365.612C26.5397 365.816 26.4227 366.091 26.4219 366.379V367.466H48.5805V366.379Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60156 391.166C8.6014 391.763 8.71713 392.355 8.94214 392.906C9.16715 393.458 9.49703 393.959 9.91293 394.381C10.3288 394.803 10.8226 395.138 11.366 395.367C11.9095 395.595 12.4919 395.712 13.0801 395.712H62.3438C62.9319 395.712 63.5144 395.595 64.0578 395.367C64.6012 395.138 65.095 394.803 65.5109 394.381C65.9268 393.959 66.2567 393.458 66.4817 392.906C66.7067 392.355 66.8224 391.763 66.8223 391.166V380.938H8.60156V391.166ZM23.1567 385.484C23.1567 385.182 23.2747 384.893 23.4847 384.68C23.6946 384.467 23.9794 384.347 24.2764 384.347H26.5156C26.8126 384.347 27.0974 384.467 27.3073 384.68C27.5173 384.893 27.6353 385.182 27.6353 385.484V391.166C27.6353 391.468 27.5173 391.757 27.3073 391.97C27.0974 392.183 26.8126 392.303 26.5156 392.303H24.2764C23.9794 392.303 23.6946 392.183 23.4847 391.97C23.2747 391.757 23.1567 391.468 23.1567 391.166V385.484ZM15.3193 385.484C15.3193 385.182 15.4373 384.893 15.6473 384.68C15.8572 384.467 16.142 384.347 16.439 384.347H18.6782C18.9752 384.347 19.26 384.467 19.4699 384.68C19.6799 384.893 19.7979 385.182 19.7979 385.484V391.166C19.7979 391.468 19.6799 391.757 19.4699 391.97C19.26 392.183 18.9752 392.303 18.6782 392.303H16.439C16.142 392.303 15.8572 392.183 15.6473 391.97C15.4373 391.757 15.3193 391.468 15.3193 391.166V385.484Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.391 368.078C90.2433 368.143 90.0772 368.144 89.929 368.08C89.7808 368.017 89.6626 367.894 89.6002 367.739L89.15 366.599L88.6997 367.735C88.6374 367.89 88.5192 368.013 88.371 368.077C88.2228 368.14 88.0566 368.14 87.9089 368.075C87.7613 368.009 87.6444 367.885 87.5839 367.729C87.5233 367.573 87.5242 367.398 87.5861 367.242L89.15 363.289L90.717 367.246C90.779 367.401 90.7798 367.576 90.7193 367.732C90.6588 367.888 90.5419 368.013 90.3942 368.078H90.391Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1532 356.838L87.5861 352.882C87.5242 352.726 87.5233 352.551 87.5839 352.395C87.6444 352.239 87.7613 352.115 87.9089 352.049C88.0566 351.984 88.2228 351.984 88.371 352.047C88.5192 352.111 88.6374 352.234 88.6997 352.389L89.1532 353.528L89.6035 352.392C89.6658 352.237 89.784 352.114 89.9322 352.051C90.0804 351.987 90.2465 351.988 90.3942 352.053C90.5419 352.118 90.6588 352.243 90.7193 352.399C90.7798 352.555 90.779 352.73 90.717 352.885L89.1532 356.838Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7145 360.602C91.5885 360.601 90.5001 361.02 89.6484 361.78C88.7966 362.541 88.2386 363.592 88.0762 364.742C88.0643 364.829 88.0705 364.917 88.0943 365.001C88.1182 365.085 88.1592 365.162 88.2145 365.228C88.2699 365.295 88.3384 365.348 88.4153 365.384C88.4922 365.421 88.5759 365.44 88.6605 365.44H89.8494C89.9837 365.439 90.1137 365.391 90.2173 365.303C90.321 365.215 90.3919 365.092 90.418 364.956C90.5261 364.41 90.8137 363.919 91.2321 363.566C91.6506 363.213 92.1743 363.021 92.7145 363.021H95.0578V360.602H92.7145Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7145 357.107C92.1743 357.107 91.6506 356.914 91.2321 356.562C90.8137 356.209 90.5261 355.718 90.418 355.171C90.3919 355.035 90.321 354.913 90.2173 354.825C90.1137 354.736 89.9837 354.688 89.8494 354.688H88.6605C88.5759 354.688 88.4922 354.707 88.4153 354.743C88.3384 354.78 88.2699 354.833 88.2145 354.899C88.1592 354.965 88.1182 355.043 88.0943 355.126C88.0705 355.21 88.0643 355.299 88.0762 355.385C88.2386 356.535 88.7966 357.587 89.6484 358.347C90.5001 359.108 91.5885 359.526 92.7145 359.526H95.0578V357.107H92.7145Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8219 356.301H97.3169C97.1458 356.301 96.9818 356.363 96.8608 356.475C96.7398 356.586 96.6719 356.737 96.6719 356.895V363.233C96.6719 363.39 96.7398 363.542 96.8608 363.653C96.9818 363.764 97.1458 363.827 97.3169 363.827H98.8219V356.301Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.849 395.544C133.983 395.544 135.08 395.126 135.938 394.366C136.796 393.605 137.359 392.554 137.522 391.404C137.534 391.317 137.528 391.229 137.504 391.145C137.48 391.061 137.439 390.984 137.383 390.917C137.327 390.851 137.258 390.798 137.181 390.762C137.103 390.725 137.019 390.706 136.934 390.706H135.736C135.6 390.707 135.469 390.755 135.365 390.843C135.261 390.931 135.189 391.054 135.163 391.19C135.054 391.736 134.764 392.227 134.342 392.58C133.921 392.933 133.393 393.125 132.849 393.125H131.078V395.544H132.849Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.849 399.039C133.393 399.039 133.921 399.232 134.342 399.584C134.764 399.937 135.054 400.428 135.163 400.975C135.189 401.111 135.261 401.233 135.365 401.321C135.469 401.409 135.6 401.458 135.736 401.458H136.934C137.019 401.458 137.103 401.439 137.181 401.403C137.258 401.366 137.327 401.313 137.383 401.247C137.439 401.181 137.48 401.103 137.504 401.019C137.528 400.936 137.534 400.847 137.522 400.761C137.359 399.611 136.796 398.559 135.938 397.799C135.08 397.038 133.983 396.62 132.849 396.62H131.078V399.039H132.849Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.852 399.846H128.98C129.109 399.846 129.232 399.783 129.322 399.672C129.413 399.56 129.464 399.409 129.464 399.251V392.914C129.464 392.756 129.413 392.605 129.322 392.493C129.232 392.382 129.109 392.319 128.98 392.319H127.852V399.846Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.644 355.764H100.506C100.345 355.764 100.19 355.827 100.076 355.94C99.9625 356.053 99.8984 356.206 99.8984 356.365V364.383C99.8984 364.543 99.9625 364.696 100.076 364.809C100.19 364.921 100.345 364.985 100.506 364.985H126.644C127.343 364.985 128.013 365.259 128.507 365.748C129.001 366.237 129.278 366.9 129.278 367.591C129.278 368.282 129.001 368.945 128.507 369.433C128.013 369.922 127.343 370.197 126.644 370.197H124.618V379.418H126.644C129.815 379.418 132.855 378.172 135.097 375.954C137.339 373.736 138.599 370.727 138.599 367.591C138.599 364.454 137.339 361.446 135.097 359.228C132.855 357.01 129.815 355.764 126.644 355.764Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9331 376.729C95.7682 376.729 92.733 377.976 90.4951 380.194C88.2572 382.412 87 385.42 87 388.556C87 391.693 88.2572 394.701 90.4951 396.919C92.733 399.137 95.7682 400.383 98.9331 400.383H125.631C125.792 400.383 125.946 400.32 126.06 400.207C126.174 400.095 126.238 399.942 126.238 399.782V391.764C126.238 391.604 126.174 391.451 126.06 391.339C125.946 391.226 125.792 391.162 125.631 391.162H98.9331C98.2358 391.162 97.567 390.888 97.0739 390.399C96.5808 389.91 96.3038 389.248 96.3038 388.556C96.3038 387.865 96.5808 387.202 97.0739 386.714C97.567 386.225 98.2358 385.951 98.9331 385.951H100.956V376.729H98.9331Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 375.709L115.099 370.815H111.207L107.961 378.892H111.529C111.621 378.892 111.712 378.912 111.795 378.95C111.878 378.988 111.95 379.043 112.008 379.112C112.065 379.181 112.106 379.261 112.127 379.346C112.148 379.432 112.148 379.521 112.128 379.607L111.173 383.718L117.636 376.509H113.709C113.609 376.51 113.51 376.487 113.421 376.443C113.332 376.399 113.255 376.335 113.198 376.256C113.141 376.177 113.105 376.086 113.093 375.99C113.082 375.895 113.095 375.798 113.131 375.709Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.074 367.59H104.535C103.878 367.59 103.247 367.845 102.781 368.298C102.316 368.752 102.055 369.367 102.055 370.009V386.137C102.055 386.778 102.316 387.394 102.781 387.847C103.247 388.301 103.878 388.556 104.535 388.556H121.074C121.732 388.556 122.363 388.301 122.828 387.847C123.293 387.394 123.555 386.778 123.555 386.137V370.009C123.555 369.367 123.293 368.752 122.828 368.298C122.363 367.845 121.732 367.59 121.074 367.59ZM119.289 376.267L110.269 386.53C110.178 386.632 110.056 386.701 109.921 386.728C109.785 386.754 109.645 386.736 109.522 386.675C109.398 386.615 109.299 386.517 109.24 386.395C109.18 386.274 109.164 386.137 109.194 386.005L110.53 380.144H106.791C106.691 380.144 106.592 380.12 106.503 380.074C106.413 380.028 106.337 379.962 106.28 379.881C106.223 379.8 106.187 379.707 106.175 379.61C106.164 379.512 106.176 379.414 106.212 379.322L109.971 369.792C110.016 369.678 110.095 369.58 110.199 369.511C110.302 369.441 110.424 369.404 110.55 369.404H115.811C115.912 369.404 116.011 369.428 116.1 369.474C116.189 369.52 116.266 369.586 116.323 369.667C116.38 369.747 116.415 369.841 116.427 369.938C116.439 370.036 116.426 370.134 116.39 370.226L114.402 375.268H118.819C118.938 375.269 119.054 375.302 119.153 375.364C119.253 375.427 119.332 375.516 119.382 375.621C119.431 375.726 119.449 375.843 119.433 375.957C119.416 376.072 119.367 376.179 119.289 376.267Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.209 388.068C135.357 388.003 135.523 388.002 135.671 388.066C135.819 388.129 135.937 388.252 136 388.407L136.45 389.547L136.9 388.411C136.963 388.256 137.081 388.133 137.229 388.069C137.377 388.006 137.543 388.006 137.691 388.071C137.839 388.137 137.956 388.261 138.016 388.417C138.077 388.573 138.076 388.748 138.014 388.904L136.45 392.857L134.883 388.9C134.821 388.745 134.82 388.57 134.881 388.414C134.941 388.258 135.058 388.133 135.206 388.068H135.209Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.447 399.308L138.014 403.264C138.076 403.42 138.077 403.595 138.016 403.751C137.956 403.907 137.839 404.031 137.691 404.097C137.543 404.162 137.377 404.162 137.229 404.099C137.081 404.035 136.963 403.912 136.9 403.757L136.447 402.617L135.997 403.754C135.934 403.909 135.816 404.032 135.668 404.095C135.52 404.159 135.353 404.158 135.206 404.093C135.058 404.028 134.941 403.903 134.881 403.747C134.82 403.591 134.821 403.416 134.883 403.261L136.447 399.308Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 384.28H164.069V387.315H158V384.28Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 390.35H164.071V393.385H158V390.35Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.93 384.28H246V387.315H239.93V384.28Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.93 378.21H245.999V381.245H239.93V378.21Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.894 387.315V378.21C236.894 376.536 238.255 375.175 239.928 375.175H242.963V361.517C242.963 360.68 242.282 360 241.446 360H233.6C232.973 361.766 231.286 363.035 229.308 363.035C227.329 363.035 225.642 361.766 225.015 360H221.721V363.035H218.687V360H215.652V363.035H212.618V360H209.583V363.035H206.549V360H203.514V363.035H200.48V360H197.445V363.035H194.411V360H191.376V363.035H188.342V360H162.549C161.712 360 161.031 360.68 161.031 361.517V381.245H164.066C165.739 381.245 167.1 382.606 167.1 384.28V393.385C167.1 395.059 165.739 396.42 164.066 396.42H161.031V404.007C161.031 404.845 161.712 405.525 162.549 405.525H173.36C174.036 402.909 176.415 400.972 179.238 400.972C182.062 400.972 184.439 402.909 185.116 405.525H241.446C242.282 405.525 242.963 404.845 242.963 404.007V390.35H239.928C238.255 390.35 236.894 388.989 236.894 387.315ZM238.411 363.035C239.249 363.035 239.928 363.715 239.928 364.552C239.928 365.39 239.249 366.07 238.411 366.07C237.574 366.07 236.894 365.39 236.894 364.552C236.894 363.715 237.574 363.035 238.411 363.035ZM165.583 402.49C164.745 402.49 164.066 401.81 164.066 400.972C164.066 400.135 164.745 399.455 165.583 399.455C166.421 399.455 167.1 400.135 167.1 400.972C167.1 401.81 166.421 402.49 165.583 402.49ZM165.583 372.14C164.745 372.14 164.066 371.46 164.066 370.622C164.066 369.785 164.745 369.105 165.583 369.105C166.421 369.105 167.1 369.785 167.1 370.622C167.1 371.46 166.421 372.14 165.583 372.14ZM165.583 366.07C164.745 366.07 164.066 365.39 164.066 364.552C164.066 363.715 164.745 363.035 165.583 363.035C166.421 363.035 167.1 363.715 167.1 364.552C167.1 365.39 166.421 366.07 165.583 366.07ZM189.859 400.972V394.902H197.445V400.972H189.859ZM208.066 400.972H200.48V394.902H208.066V400.972ZM223.239 400.972H217.17V394.902H223.239V400.972ZM227.79 390.35H224.756V387.315H221.721V390.35H218.687V387.315H215.652V390.35H212.618V387.315H209.583V390.35H206.549V387.315H203.514V390.35H200.48V387.315H197.445V390.35H194.411V387.315H191.376V390.35H188.342V387.315H185.307V390.35H182.273V387.315H179.238V390.35H176.204V387.315C174.53 387.315 173.169 385.954 173.169 384.28V369.105C173.169 367.431 174.53 366.07 176.204 366.07H227.79C229.464 366.07 230.825 367.431 230.825 369.105V384.28C230.825 385.954 229.464 387.315 227.79 387.315V390.35ZM235.377 400.972H229.308V394.902H235.377V400.972Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.203 369.105V384.28H227.791L227.79 369.105H176.203ZM183.789 379.728C182.113 379.728 180.755 378.37 180.755 376.693C180.755 375.016 182.113 373.658 183.789 373.658C185.466 373.658 186.824 375.016 186.824 376.693C186.824 378.37 185.466 379.728 183.789 379.728ZM220.203 379.728C218.527 379.728 217.169 378.37 217.169 376.693C217.169 375.016 218.527 373.658 220.203 373.658C221.88 373.658 223.238 375.016 223.238 376.693C223.238 378.37 221.88 379.728 220.203 379.728Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.105 367.049C310.655 367.453 311.213 367.956 311.22 368.291C311.233 368.974 309.26 369.872 305.933 370.217L305.899 368.391C305.897 368.315 305.866 368.243 305.811 368.19C305.756 368.138 305.683 368.109 305.607 368.11L301.695 368.184C301.619 368.185 301.547 368.217 301.494 368.272C301.442 368.326 301.413 368.4 301.414 368.476L301.449 370.302C298.11 370.083 296.106 369.259 296.093 368.576C296.086 368.24 296.626 367.717 298.159 367.256C299.939 366.772 301.775 366.524 303.62 366.517C305.464 366.454 307.308 366.633 309.105 367.049ZM301.992 368.752L302.375 389.072L304.122 393.136L305.714 389.009L305.331 368.689L301.992 368.752ZM303.588 364.833C301.743 364.84 299.907 365.089 298.127 365.572C296.594 366.034 296.054 366.558 296.06 366.893L296.075 367.613C296.651 367.192 297.302 366.885 297.993 366.707C299.824 366.208 301.712 365.952 303.609 365.944C305.505 365.881 307.402 366.066 309.25 366.495C309.947 366.647 310.609 366.929 311.201 367.328L311.188 366.608C311.181 366.273 310.623 365.77 309.073 365.367C307.276 364.95 305.432 364.771 303.588 364.833Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.105 397.176C310.655 397.58 311.213 398.083 311.22 398.418C311.233 399.101 309.26 399.999 305.933 400.344L305.899 398.518C305.897 398.442 305.866 398.37 305.811 398.317C305.756 398.265 305.683 398.236 305.607 398.237L301.695 398.311C301.619 398.312 301.547 398.344 301.494 398.399C301.442 398.453 301.413 398.527 301.414 398.603L301.449 400.429C298.11 400.21 296.106 399.386 296.093 398.703C296.086 398.367 296.626 397.844 298.159 397.383C299.939 396.899 301.775 396.651 303.62 396.644C305.464 396.581 307.308 396.76 309.105 397.176ZM301.992 398.879L302.375 419.199L304.122 423.263L305.714 419.136L305.331 398.816L301.992 398.879ZM303.588 394.96C301.743 394.967 299.907 395.216 298.127 395.699C296.594 396.161 296.054 396.685 296.06 397.02L296.075 397.74C296.651 397.319 297.302 397.012 297.993 396.834C299.824 396.335 301.712 396.079 303.609 396.071C305.505 396.007 307.402 396.193 309.25 396.622C309.947 396.774 310.609 397.056 311.201 397.455L311.188 396.735C311.181 396.399 310.623 395.897 309.073 395.493C307.276 395.077 305.432 394.898 303.588 394.96Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.832 367.417C292.381 367.821 292.94 368.324 292.946 368.659C292.96 369.342 290.987 370.24 287.659 370.585L287.625 368.759C287.624 368.683 287.592 368.611 287.538 368.558C287.483 368.506 287.41 368.477 287.334 368.478L283.422 368.552C283.346 368.554 283.274 368.585 283.221 368.64C283.168 368.694 283.139 368.768 283.141 368.844L283.175 370.67C279.837 370.451 277.832 369.627 277.819 368.944C277.813 368.609 278.353 368.085 279.886 367.624C281.666 367.14 283.502 366.892 285.347 366.885C287.19 366.822 289.034 367.001 290.832 367.417ZM283.718 369.12L284.101 389.44L285.848 393.505L287.441 389.377L287.058 369.057L283.718 369.12ZM285.315 365.201C283.47 365.209 281.634 365.457 279.853 365.94C278.321 366.402 277.781 366.926 277.787 367.261L277.801 367.981C278.378 367.561 279.029 367.253 279.72 367.075C281.55 366.577 283.438 366.32 285.336 366.312C287.232 366.249 289.128 366.434 290.977 366.863C291.674 367.015 292.336 367.298 292.928 367.696L292.914 366.976C292.908 366.641 292.349 366.138 290.8 365.735C289.002 365.319 287.159 365.139 285.315 365.201Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.832 397.544C292.381 397.948 292.94 398.451 292.946 398.786C292.96 399.469 290.987 400.367 287.659 400.712L287.625 398.886C287.624 398.81 287.592 398.738 287.538 398.685C287.483 398.633 287.41 398.604 287.334 398.605L283.422 398.679C283.346 398.68 283.274 398.712 283.221 398.767C283.168 398.821 283.139 398.895 283.141 398.971L283.175 400.797C279.837 400.578 277.832 399.754 277.819 399.071C277.813 398.736 278.353 398.212 279.886 397.751C281.666 397.267 283.502 397.019 285.347 397.012C287.19 396.949 289.034 397.128 290.832 397.544ZM283.718 399.247L284.101 419.567L285.848 423.632L287.441 419.504L287.058 399.184L283.718 399.247ZM285.315 395.328C283.47 395.336 281.634 395.584 279.853 396.067C278.321 396.529 277.781 397.053 277.787 397.388L277.801 398.108C278.378 397.688 279.029 397.38 279.72 397.202C281.55 396.704 283.438 396.447 285.336 396.439C287.232 396.376 289.128 396.561 290.977 396.99C291.674 397.142 292.336 397.425 292.928 397.823L292.914 397.103C292.908 396.768 292.349 396.265 290.8 395.862C289.002 395.446 287.159 395.266 285.315 395.328Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.371 367.786C272.92 368.19 273.479 368.693 273.485 369.028C273.499 369.711 271.526 370.61 268.199 370.955L268.164 369.128C268.163 369.052 268.131 368.98 268.077 368.928C268.022 368.875 267.949 368.846 267.873 368.848L263.961 368.921C263.885 368.923 263.813 368.954 263.76 369.009C263.707 369.064 263.679 369.137 263.68 369.213L263.715 371.039C260.376 370.82 258.371 369.997 258.358 369.314C258.352 368.978 258.892 368.455 260.425 367.993C262.205 367.509 264.041 367.261 265.886 367.254C267.729 367.191 269.574 367.37 271.371 367.786ZM264.258 369.489L264.64 389.809L266.387 393.874L267.98 389.746L267.597 369.426L264.258 369.489ZM265.854 365.571C264.009 365.578 262.173 365.826 260.392 366.31C258.86 366.771 258.32 367.295 258.326 367.63L258.34 368.35C258.917 367.93 259.568 367.622 260.259 367.444C262.089 366.946 263.978 366.689 265.875 366.681C267.771 366.618 269.667 366.803 271.516 367.232C272.213 367.384 272.875 367.667 273.467 368.065L273.453 367.345C273.447 367.01 272.888 366.507 271.339 366.104C269.542 365.688 267.698 365.508 265.854 365.571Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.371 397.912C272.92 398.316 273.479 398.819 273.485 399.154C273.499 399.837 271.526 400.736 268.199 401.081L268.164 399.254C268.163 399.178 268.131 399.106 268.077 399.054C268.022 399.001 267.949 398.972 267.873 398.973L263.961 399.047C263.885 399.049 263.813 399.08 263.76 399.135C263.707 399.19 263.679 399.263 263.68 399.339L263.715 401.165C260.376 400.946 258.371 400.123 258.358 399.44C258.352 399.104 258.892 398.581 260.425 398.119C262.205 397.635 264.041 397.387 265.886 397.38C267.729 397.317 269.574 397.496 271.371 397.912ZM264.258 399.615L264.64 419.935L266.387 424L267.98 419.872L267.597 399.552L264.258 399.615ZM265.854 395.696C264.009 395.704 262.173 395.952 260.392 396.435C258.86 396.897 258.32 397.421 258.326 397.756L258.34 398.476C258.917 398.056 259.568 397.748 260.259 397.57C262.089 397.072 263.978 396.815 265.875 396.807C267.771 396.744 269.667 396.929 271.516 397.358C272.213 397.51 272.875 397.793 273.467 398.191L273.453 397.471C273.447 397.136 272.888 396.633 271.339 396.23C269.542 395.814 267.698 395.634 265.854 395.696Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 417,
    width: 101.884,
    height: 20.5714,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 440.92,
    width: 101.884,
    height: 20.5714,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.775 421.706C104.768 421.706 104.791 421.701 104.85 421.752C104.911 421.806 104.99 421.904 105.077 422.062C105.252 422.379 105.422 422.865 105.57 423.498C105.864 424.759 106.05 426.521 106.05 428.481C106.05 430.442 105.864 432.204 105.57 433.465C105.423 434.098 105.252 434.583 105.077 434.9C104.99 435.059 104.911 435.157 104.85 435.211C104.791 435.262 104.768 435.258 104.775 435.258C104.769 435.257 104.745 435.249 104.702 435.211C104.64 435.157 104.562 435.059 104.475 434.9C104.3 434.583 104.129 434.098 103.981 433.465C103.687 432.204 103.502 430.442 103.502 428.481C103.502 426.521 103.687 424.759 103.981 423.498C104.129 422.865 104.3 422.379 104.475 422.062C104.562 421.904 104.64 421.806 104.702 421.752C104.745 421.715 104.769 421.707 104.775 421.706Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 458.221C9.09951 458.218 9.07665 458.209 9.03809 458.174C8.97569 458.117 8.89663 458.015 8.80859 457.85C8.63269 457.52 8.46151 457.017 8.31348 456.361C8.01879 455.056 7.83302 453.233 7.83301 451.206C7.83301 449.179 8.01881 447.356 8.31348 446.051C8.46156 445.395 8.63264 444.891 8.80859 444.562C8.8967 444.396 8.97568 444.294 9.03809 444.237C9.09769 444.183 9.11941 444.19 9.10742 444.19C9.09475 444.19 9.1158 444.183 9.17578 444.237C9.23821 444.294 9.3181 444.396 9.40625 444.562C9.5822 444.891 9.75232 445.395 9.90039 446.051C10.1951 447.356 10.3809 449.179 10.3809 451.206C10.3808 453.233 10.1951 455.056 9.90039 456.361C9.7524 457.017 9.5821 457.52 9.40625 457.85C9.31813 458.015 9.2382 458.117 9.17578 458.174C9.13813 458.208 9.11582 458.218 9.10742 458.221Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.861 421.706C102.854 421.706 102.877 421.701 102.936 421.752C102.997 421.806 103.076 421.904 103.163 422.062C103.338 422.379 103.508 422.864 103.656 423.498C103.95 424.759 104.136 426.521 104.136 428.481C104.136 430.442 103.95 432.204 103.656 433.465C103.508 434.098 103.338 434.583 103.163 434.9C103.076 435.059 102.997 435.157 102.936 435.211C102.877 435.262 102.854 435.258 102.861 435.258C102.855 435.257 102.831 435.249 102.788 435.211C102.726 435.157 102.648 435.059 102.561 434.9C102.386 434.583 102.215 434.098 102.067 433.465C101.773 432.204 101.588 430.442 101.588 428.481C101.588 426.521 101.773 424.759 102.067 423.498C102.215 422.865 102.386 422.379 102.561 422.062C102.648 421.904 102.726 421.806 102.788 421.752C102.831 421.715 102.855 421.707 102.861 421.706Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7822 458.221C10.7406 458.221 10.5927 458.181 10.3789 457.83C10.1793 457.503 9.98498 457.003 9.81641 456.35C9.4808 455.049 9.26857 453.23 9.26856 451.206C9.26856 449.182 9.4808 447.363 9.81641 446.062C9.98495 445.409 10.1793 444.909 10.3789 444.582C10.5928 444.231 10.7406 444.19 10.7822 444.19C10.8242 444.191 10.9721 444.232 11.1855 444.582C11.3851 444.909 11.5795 445.409 11.748 446.062C12.0836 447.363 12.2949 449.182 12.2949 451.206C12.2949 453.23 12.0837 455.049 11.748 456.35C11.5795 457.003 11.3851 457.503 11.1855 457.83C10.9721 458.18 10.8242 458.221 10.7822 458.221Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.187 422.185C101.248 422.185 101.395 422.231 101.6 422.534C101.795 422.824 101.988 423.269 102.155 423.855C102.489 425.023 102.7 426.658 102.7 428.481C102.7 430.305 102.489 431.941 102.155 433.108C101.988 433.695 101.795 434.14 101.6 434.43C101.395 434.733 101.248 434.779 101.187 434.779C101.125 434.779 100.978 434.733 100.773 434.43C100.578 434.14 100.386 433.694 100.219 433.108C99.8853 431.941 99.6738 430.305 99.6738 428.481C99.6739 426.658 99.8853 425.023 100.219 423.855C100.386 423.269 100.578 422.824 100.773 422.534C100.978 422.231 101.125 422.185 101.187 422.185Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6963 457.264C12.6352 457.264 12.4881 457.217 12.2832 456.914C12.0876 456.624 11.895 456.179 11.7275 455.593C11.3941 454.426 11.1826 452.79 11.1826 450.967C11.1826 449.144 11.3941 447.507 11.7275 446.34C11.895 445.754 12.0876 445.308 12.2832 445.019C12.4881 444.715 12.6352 444.669 12.6963 444.669C12.7575 444.669 12.9046 444.716 13.1094 445.019C13.3049 445.308 13.4966 445.754 13.6641 446.34C13.9975 447.507 14.209 449.144 14.209 450.967C14.209 452.79 13.9975 454.426 13.6641 455.593C13.4966 456.179 13.305 456.624 13.1094 456.914C12.9046 457.217 12.7576 457.264 12.6963 457.264Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2725 423.619C99.3688 423.619 99.518 423.674 99.708 423.905C99.8958 424.134 100.083 424.488 100.248 424.962C100.576 425.905 100.786 427.234 100.786 428.721C100.786 430.207 100.576 431.536 100.248 432.479C100.083 432.953 99.8957 433.308 99.708 433.536C99.5182 433.767 99.3687 433.822 99.2725 433.822C99.1762 433.822 99.0267 433.767 98.8369 433.536C98.6492 433.308 98.4625 432.953 98.2979 432.479C97.9699 431.536 97.7598 430.207 97.7598 428.721C97.7598 427.234 97.9699 425.905 98.2979 424.962C98.4625 424.489 98.6492 424.134 98.8369 423.905C99.0268 423.674 99.1761 423.619 99.2725 423.619Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6104 456.307C14.514 456.307 14.3648 456.252 14.1748 456.021C13.9871 455.792 13.7994 455.437 13.6348 454.964C13.3068 454.021 13.0967 452.692 13.0967 451.205C13.0967 449.718 13.3068 448.389 13.6348 447.446C13.7994 446.973 13.9871 446.618 14.1748 446.39C14.3647 446.159 14.5141 446.104 14.6104 446.104C14.7067 446.104 14.8561 446.159 15.0459 446.39C15.2336 446.618 15.4203 446.973 15.585 447.446C15.9129 448.389 16.123 449.718 16.123 451.205C16.123 452.692 15.9129 454.021 15.585 454.964C15.4203 455.437 15.2336 455.792 15.0459 456.021C14.856 456.251 14.7067 456.307 14.6104 456.307Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3584 425.533C97.6671 425.533 98.0396 425.774 98.3584 426.372C98.668 426.953 98.8721 427.782 98.8721 428.721C98.8721 429.659 98.668 430.489 98.3584 431.069C98.0396 431.667 97.6671 431.909 97.3584 431.909C97.0498 431.909 96.6771 431.667 96.3584 431.069C96.0489 430.489 95.8457 429.659 95.8457 428.721C95.8457 427.782 96.0488 426.953 96.3584 426.372C96.6771 425.774 97.0498 425.533 97.3584 425.533Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2793 454.394C16.0648 454.394 15.7462 454.192 15.458 453.574C15.1849 452.989 15.0049 452.152 15.0049 451.206C15.0049 450.26 15.1849 449.423 15.458 448.838C15.7463 448.22 16.0648 448.018 16.2793 448.018C16.4938 448.018 16.8124 448.22 17.1006 448.838C17.3737 449.423 17.5527 450.26 17.5527 451.206C17.5527 452.152 17.3737 452.989 17.1006 453.574C16.8125 454.192 16.4938 454.393 16.2793 454.394Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.67918,
    cy: 429.199,
    rx: 1.19582,
    ry: 5.50166,
    transform: "rotate(-180 7.67918 429.199)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.257,
    cy: 451.205,
    rx: 1.19582,
    ry: 5.50166,
    transform: "rotate(-180 105.257 451.205)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6064 448.083C95.0313 448.083 93.75 449.365 93.75 450.94C93.75 452.515 95.0313 453.797 96.6064 453.797C98.1816 453.797 99.4629 452.515 99.4629 450.94C99.4629 449.365 98.1816 448.083 96.6064 448.083ZM96.6064 453.354C95.2756 453.354 94.1925 452.271 94.1925 450.94C94.1925 449.609 95.2756 448.526 96.6064 448.526C97.9373 448.526 99.0204 449.609 99.0204 450.94C99.0204 452.271 97.9375 453.354 96.6064 453.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7151 450.698H96.8301V449.813C96.8301 449.691 96.7312 449.592 96.6088 449.592C96.4865 449.592 96.3875 449.691 96.3875 449.813V450.698H95.5025C95.3802 450.698 95.2812 450.797 95.2812 450.92C95.2812 451.042 95.3802 451.141 95.5025 451.141H96.3875V452.026C96.3875 452.148 96.4865 452.247 96.6088 452.247C96.7312 452.247 96.8301 452.148 96.8301 452.026V451.141H97.7151C97.8375 451.141 97.9364 451.042 97.9364 450.92C97.9364 450.797 97.8375 450.698 97.7151 450.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 426.143C15.8126 426.143 14.5312 427.424 14.5312 428.999C14.5312 430.575 15.8126 431.856 17.3877 431.856C18.9628 431.856 20.2441 430.575 20.2441 428.999C20.2441 427.424 18.9628 426.143 17.3877 426.143ZM17.3877 431.414C16.0568 431.414 14.9738 430.331 14.9738 428.999C14.9738 427.668 16.0568 426.585 17.3877 426.585C18.7186 426.585 19.8016 427.668 19.8016 428.999C19.8016 430.331 18.7188 431.414 17.3877 431.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4964 428.758H17.6113V427.873C17.6113 427.751 17.5124 427.651 17.3901 427.651C17.2677 427.651 17.1688 427.751 17.1688 427.873V428.758H16.2838C16.1614 428.758 16.0625 428.857 16.0625 428.979C16.0625 429.101 16.1614 429.2 16.2838 429.2H17.1688V430.086C17.1688 430.208 17.2677 430.307 17.3901 430.307C17.5124 430.307 17.6113 430.208 17.6113 430.086V429.2H18.4964C18.6187 429.2 18.7176 429.101 18.7176 428.979C18.7176 428.857 18.6187 428.758 18.4964 428.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2939 431.246C87.719 431.246 86.4375 429.965 86.4375 428.389C86.4375 426.814 87.719 425.532 89.2939 425.532C90.8691 425.532 92.1504 426.814 92.1504 428.389C92.1504 429.965 90.8689 431.246 89.2939 431.246ZM89.2939 425.975C87.9629 425.975 86.88 427.058 86.88 428.389C86.88 429.72 87.9629 430.804 89.2939 430.804C90.625 430.804 91.7079 429.72 91.7079 428.389C91.7079 427.058 90.625 425.975 89.2939 425.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7002 453.797C23.1253 453.797 21.8438 452.515 21.8438 450.94C21.8438 449.365 23.1253 448.083 24.7002 448.083C26.2753 448.083 27.5566 449.365 27.5566 450.94C27.5566 452.515 26.2751 453.797 24.7002 453.797ZM24.7002 448.526C23.3691 448.526 22.2863 449.609 22.2863 450.94C22.2863 452.271 23.3691 453.354 24.7002 453.354C26.0313 453.354 27.1141 452.271 27.1141 450.94C27.1141 449.609 26.0313 448.526 24.7002 448.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4026 428.631H88.19C88.0679 428.631 87.9688 428.532 87.9688 428.41C87.9688 428.287 88.0679 428.188 88.19 428.188H90.4026C90.5247 428.188 90.6239 428.287 90.6239 428.41C90.6239 428.532 90.5247 428.631 90.4026 428.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8089 451.182H23.5963C23.4741 451.182 23.375 451.082 23.375 450.96C23.375 450.838 23.4741 450.739 23.5963 450.739H25.8089C25.931 450.739 26.0301 450.838 26.0301 450.96C26.0301 451.082 25.931 451.182 25.8089 451.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.929 472.892V475.693C182.922 476.468 182.753 477.233 182.433 477.938C182.113 478.642 181.649 479.271 181.071 479.783C179.871 480.862 178.316 481.455 176.707 481.447H162.097C161.882 481.447 161.676 481.361 161.524 481.208C161.372 481.055 161.286 480.847 161.286 480.631C161.286 480.415 161.372 480.207 161.524 480.054C161.676 479.901 161.882 479.815 162.097 479.815H176.707C177.915 479.826 179.084 479.385 179.987 478.578C180.396 478.218 180.725 477.774 180.953 477.277C181.18 476.78 181.301 476.241 181.308 475.693V472.892H182.929ZM167.797 469.911V471.219H169.459V469.911H167.797ZM181.306 436.075V430.404C181.306 430.188 181.392 429.98 181.544 429.827C181.696 429.674 181.902 429.588 182.117 429.588C182.332 429.588 182.538 429.674 182.69 429.827C182.842 429.98 182.928 430.188 182.928 430.404V436.073L184.649 437.419V441.427H179.588V437.419L181.306 436.075V436.075ZM167.808 436.081V430.404C167.808 430.188 167.894 429.98 168.046 429.827C168.198 429.674 168.404 429.588 168.619 429.588C168.834 429.588 169.04 429.674 169.192 429.827C169.344 429.98 169.43 430.188 169.43 430.404V436.068L171.159 437.42V441.428H166.097V437.419L167.808 436.081V436.081ZM181.288 469.911V471.219H182.95V469.911H181.288ZM184.649 445.871H179.588V468.279H184.649V445.871ZM186.979 443.059H177.258C177.252 443.06 177.247 443.062 177.243 443.066C177.239 443.07 177.237 443.076 177.236 443.081V444.217C177.236 444.223 177.237 444.228 177.24 444.232H177.243C177.247 444.236 177.252 444.239 177.258 444.239H186.978C186.981 444.24 186.984 444.239 186.987 444.238C186.99 444.237 186.992 444.236 186.994 444.234C186.996 444.232 186.998 444.229 186.999 444.226C187 444.223 187 444.22 187 444.217V443.081C187 443.078 187 443.075 186.999 443.072C186.998 443.07 186.996 443.067 186.994 443.065C186.992 443.063 186.99 443.061 186.987 443.06C186.984 443.059 186.981 443.059 186.978 443.059H186.979ZM162.097 477.696H165.585C166.606 477.694 167.585 477.285 168.307 476.558C169.029 475.831 169.436 474.846 169.439 473.818V472.892H167.817V473.818C167.815 474.413 167.579 474.983 167.161 475.404C166.743 475.825 166.176 476.062 165.585 476.064H162.097C161.882 476.064 161.676 476.15 161.524 476.303C161.372 476.456 161.286 476.664 161.286 476.88C161.286 477.097 161.372 477.304 161.524 477.457C161.676 477.61 161.882 477.696 162.097 477.696ZM171.159 445.871H166.097V468.279H171.159V445.871V445.871ZM173.487 443.059H163.768C163.762 443.06 163.757 443.062 163.753 443.066C163.749 443.07 163.747 443.076 163.746 443.081V444.217C163.745 444.223 163.747 444.228 163.75 444.232H163.753C163.757 444.236 163.762 444.239 163.768 444.239H173.487C173.49 444.24 173.493 444.239 173.496 444.238C173.499 444.237 173.501 444.236 173.504 444.234C173.506 444.232 173.507 444.229 173.508 444.226C173.509 444.223 173.509 444.22 173.509 444.217V443.081C173.509 443.078 173.509 443.075 173.508 443.072C173.507 443.069 173.506 443.067 173.504 443.065C173.502 443.063 173.499 443.061 173.496 443.06C173.493 443.059 173.49 443.059 173.487 443.059ZM132.05 477.488C131.913 477.349 131.731 477.263 131.537 477.243C131.343 477.224 131.148 477.273 130.985 477.382C130.823 477.491 130.703 477.654 130.647 477.841C130.59 478.029 130.6 478.231 130.675 478.413C130.749 478.594 130.884 478.744 131.056 478.837C131.228 478.929 131.427 478.959 131.618 478.921C131.81 478.882 131.982 478.778 132.106 478.627C132.23 478.475 132.297 478.284 132.297 478.088C132.297 477.977 132.276 477.866 132.233 477.763C132.191 477.66 132.129 477.567 132.05 477.488ZM139.949 477.488C139.811 477.349 139.629 477.263 139.435 477.243C139.241 477.224 139.046 477.273 138.884 477.382C138.721 477.491 138.602 477.654 138.545 477.841C138.488 478.029 138.498 478.231 138.573 478.413C138.647 478.594 138.782 478.744 138.954 478.837C139.126 478.929 139.325 478.959 139.516 478.921C139.708 478.882 139.88 478.778 140.004 478.627C140.128 478.475 140.195 478.284 140.195 478.088C140.196 477.977 140.174 477.866 140.132 477.763C140.089 477.66 140.027 477.567 139.949 477.488ZM139.352 475.608C139.923 475.608 140.475 475.807 140.916 476.171C141.357 476.535 141.658 477.042 141.77 477.605C141.881 478.168 141.795 478.752 141.526 479.258C141.257 479.764 140.822 480.161 140.295 480.38C139.768 480.6 139.182 480.629 138.636 480.462C138.091 480.295 137.619 479.944 137.302 479.466C136.986 478.989 136.843 478.416 136.899 477.845C136.955 477.274 137.206 476.74 137.609 476.334C137.838 476.104 138.109 475.921 138.409 475.796C138.708 475.671 139.029 475.607 139.352 475.608ZM147.847 477.488C147.709 477.349 147.527 477.263 147.333 477.243C147.139 477.224 146.944 477.273 146.782 477.382C146.619 477.491 146.5 477.654 146.443 477.841C146.386 478.029 146.396 478.231 146.471 478.413C146.545 478.594 146.68 478.744 146.852 478.837C147.025 478.929 147.223 478.959 147.415 478.921C147.606 478.882 147.778 478.778 147.902 478.627C148.026 478.475 148.094 478.284 148.094 478.088C148.094 477.977 148.072 477.866 148.03 477.763C147.987 477.66 147.925 477.567 147.847 477.488ZM147.251 475.608C147.821 475.608 148.373 475.807 148.814 476.171C149.255 476.535 149.557 477.041 149.668 477.604C149.779 478.167 149.693 478.751 149.425 479.257C149.156 479.763 148.721 480.16 148.194 480.38C147.667 480.599 147.081 480.628 146.535 480.462C145.99 480.295 145.518 479.943 145.201 479.466C144.885 478.989 144.742 478.416 144.798 477.845C144.854 477.274 145.105 476.74 145.508 476.334C145.736 476.104 146.008 475.921 146.307 475.796C146.606 475.671 146.927 475.607 147.251 475.608ZM129.018 447.087C128.803 447.087 128.597 447.001 128.445 446.848C128.293 446.695 128.207 446.487 128.207 446.271C128.207 446.054 128.293 445.847 128.445 445.694C128.597 445.541 128.803 445.455 129.018 445.455H131.161C131.376 445.455 131.583 445.541 131.735 445.694C131.887 445.847 131.972 446.054 131.972 446.271C131.972 446.487 131.887 446.695 131.735 446.848C131.583 447.001 131.376 447.087 131.161 447.087H129.018ZM135.193 447.087C134.978 447.087 134.772 447.001 134.62 446.848C134.468 446.695 134.382 446.487 134.382 446.271C134.382 446.054 134.468 445.847 134.62 445.694C134.772 445.541 134.978 445.455 135.193 445.455H137.337C137.552 445.455 137.759 445.541 137.911 445.694C138.063 445.847 138.148 446.054 138.148 446.271C138.148 446.487 138.063 446.695 137.911 446.848C137.759 447.001 137.552 447.087 137.337 447.087H135.193ZM141.368 447.087C141.153 447.087 140.947 447.001 140.795 446.848C140.643 446.695 140.557 446.487 140.557 446.271C140.557 446.054 140.643 445.847 140.795 445.694C140.947 445.541 141.153 445.455 141.368 445.455H143.512C143.727 445.455 143.933 445.541 144.085 445.694C144.237 445.847 144.322 446.054 144.322 446.271C144.322 446.487 144.237 446.695 144.085 446.848C143.933 447.001 143.727 447.087 143.512 447.087H141.368ZM147.543 447.087C147.328 447.087 147.122 447.001 146.97 446.848C146.818 446.695 146.732 446.487 146.732 446.271C146.732 446.054 146.818 445.847 146.97 445.694C147.122 445.541 147.328 445.455 147.543 445.455H149.687C149.902 445.455 150.108 445.541 150.26 445.694C150.412 445.847 150.498 446.054 150.498 446.271C150.498 446.487 150.412 446.695 150.26 446.848C150.108 447.001 149.902 447.087 149.687 447.087H147.543ZM129.669 420.716H149.035C150.152 420.718 151.223 421.166 152.013 421.961C152.802 422.756 153.247 423.833 153.25 424.957V479.289C153.247 480.413 152.803 481.491 152.013 482.285C151.223 483.08 150.152 483.528 149.035 483.531H129.669C128.552 483.528 127.482 483.08 126.692 482.285C125.902 481.491 125.457 480.413 125.455 479.289V424.957C125.458 423.833 125.902 422.756 126.692 421.961C127.482 421.166 128.552 420.718 129.669 420.716ZM152.952 417.001C153.058 417.001 153.044 416.999 153.07 417C154.075 417.032 155.031 417.447 155.745 418.16C156.096 418.504 156.375 418.915 156.567 419.368C156.758 419.821 156.858 420.309 156.861 420.801C156.861 420.901 156.863 420.882 156.862 420.91L155.984 450.977V451.022L156.862 481.089C156.863 481.118 156.861 481.099 156.861 481.199C156.858 481.691 156.758 482.179 156.567 482.632C156.375 483.085 156.096 483.496 155.745 483.84C155.031 484.553 154.075 484.968 153.07 485C153.044 485.001 153.058 484.999 152.952 484.999H125.91C125.805 484.999 125.819 485.001 125.793 485C124.788 484.968 123.831 484.553 123.117 483.84C122.767 483.496 122.487 483.085 122.296 482.632C122.104 482.178 122.004 481.691 122.002 481.198C122.002 481.099 122 481.118 122 481.09L122.879 451.023V450.978L122 420.911C121.999 420.882 122.001 420.901 122.001 420.802C122.004 420.309 122.104 419.822 122.296 419.369C122.487 418.915 122.766 418.505 123.117 418.161C123.831 417.447 124.787 417.033 125.793 417.001C125.819 417 125.805 417.002 125.91 417.002L152.952 417.001ZM148.398 426.145H130.308V439.396H148.397V426.145H148.398ZM130.288 424.513C130.078 424.513 129.87 424.554 129.676 424.636C129.481 424.717 129.305 424.836 129.156 424.986V424.989C129.008 425.138 128.89 425.315 128.809 425.51C128.728 425.705 128.687 425.914 128.687 426.125V439.415C128.687 439.627 128.728 439.836 128.809 440.031C128.89 440.226 129.008 440.403 129.156 440.551V440.555C129.305 440.705 129.481 440.824 129.676 440.905C129.87 440.986 130.078 441.028 130.288 441.028H148.417C148.842 441.027 149.249 440.857 149.549 440.555C149.849 440.252 150.018 439.843 150.019 439.415V426.125C150.019 425.914 149.977 425.705 149.897 425.51C149.816 425.315 149.698 425.138 149.549 424.989V424.986C149.401 424.836 149.224 424.717 149.03 424.636C148.836 424.554 148.628 424.513 148.417 424.513H130.288ZM136.842 452.667L145.673 460.902C145.714 460.765 145.751 460.626 145.784 460.486C146.047 459.349 146.012 458.162 145.682 457.042C145.353 455.923 144.74 454.908 143.904 454.098C143.068 453.288 142.038 452.711 140.913 452.422C139.789 452.133 138.609 452.143 137.49 452.45C137.27 452.511 137.054 452.583 136.841 452.667H136.842ZM141.704 465.215L132.873 456.98C132.831 457.117 132.794 457.255 132.761 457.396C132.498 458.533 132.533 459.72 132.863 460.839C133.192 461.959 133.805 462.974 134.641 463.784C135.477 464.594 136.507 465.171 137.632 465.46C138.756 465.749 139.936 465.739 141.055 465.432C141.275 465.371 141.491 465.299 141.704 465.215ZM144.211 467.553H144.214C144.565 467.88 145.03 468.053 145.507 468.034C145.984 468.016 146.434 467.808 146.759 467.456L146.761 467.457L148.258 465.831L148.259 465.832L148.266 465.823L148.278 465.81L148.277 465.809L148.278 465.807C148.599 465.457 148.771 464.995 148.757 464.52C148.743 464.045 148.545 463.593 148.205 463.264L148.206 463.262L148.183 463.243L146.964 462.106C147.603 460.531 147.75 458.798 147.384 457.137C147.019 455.476 146.159 453.967 144.919 452.81C143.679 451.654 142.119 450.906 140.445 450.666C138.772 450.425 137.065 450.704 135.553 451.466L134.356 450.349V450.348L134.347 450.341L134.334 450.329L134.332 450.33L134.33 450.329C133.983 450.006 133.524 449.833 133.052 449.846C132.579 449.86 132.131 450.06 131.803 450.403L131.802 450.402L131.783 450.424L130.266 452.072C129.942 452.425 129.77 452.893 129.788 453.374C129.806 453.855 130.012 454.309 130.363 454.637L130.361 454.638L131.581 455.776C130.941 457.351 130.794 459.084 131.159 460.745C131.525 462.406 132.385 463.916 133.625 465.072C134.865 466.228 136.426 466.977 138.099 467.217C139.773 467.457 141.479 467.178 142.991 466.416L144.21 467.553H144.211ZM131.463 453.446L133.074 454.948C133.098 454.968 133.121 454.99 133.143 455.013L145.313 466.361L145.311 466.363C145.349 466.396 145.398 466.412 145.448 466.409C145.472 466.409 145.496 466.403 145.518 466.394C145.54 466.384 145.56 466.369 145.576 466.352V466.349L147.093 464.701L147.113 464.679C147.133 464.645 147.144 464.605 147.142 464.565C147.139 464.516 147.118 464.469 147.081 464.436L147.059 464.417L147.06 464.416L145.47 462.933C145.446 462.913 145.423 462.892 145.402 462.869L133.232 451.521L133.21 451.502C133.176 451.481 133.137 451.47 133.097 451.472C133.048 451.475 133.001 451.497 132.968 451.533L132.949 451.555H132.948L131.451 453.181C131.418 453.219 131.4 453.268 131.403 453.317C131.404 453.342 131.409 453.366 131.419 453.388C131.429 453.41 131.443 453.43 131.46 453.447L131.463 453.446ZM151.628 472.766V479.289C151.626 479.981 151.352 480.643 150.866 481.132C150.38 481.62 149.722 481.896 149.035 481.899H129.669C128.982 481.896 128.324 481.62 127.839 481.132C127.353 480.643 127.079 479.981 127.076 479.289V472.766H131.551C133.84 474.296 136.525 475.111 139.272 475.111C142.019 475.111 144.705 474.296 146.993 472.766H151.628ZM146.238 471.316C146.383 471.198 146.563 471.134 146.749 471.134H151.628V424.957C151.626 424.266 151.352 423.604 150.866 423.115C150.38 422.626 149.722 422.35 149.035 422.348H129.669C128.983 422.35 128.324 422.626 127.839 423.115C127.353 423.604 127.079 424.266 127.076 424.957V471.134H131.796C131.982 471.134 132.162 471.198 132.306 471.316C134.359 472.727 136.787 473.482 139.273 473.482C141.758 473.482 144.186 472.727 146.239 471.316H146.238ZM131.454 475.608C132.024 475.608 132.577 475.807 133.018 476.171C133.459 476.535 133.76 477.042 133.871 477.605C133.983 478.168 133.896 478.752 133.627 479.258C133.359 479.764 132.924 480.161 132.397 480.38C131.87 480.6 131.284 480.629 130.738 480.462C130.192 480.295 129.721 479.944 129.404 479.466C129.087 478.989 128.945 478.416 129.001 477.845C129.057 477.274 129.308 476.74 129.711 476.334C129.939 476.104 130.211 475.921 130.51 475.796C130.81 475.671 131.13 475.607 131.454 475.608H131.454Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.952 478.923C219.629 480.846 211.187 482.872 210.22 483C210.22 483 209.096 481.757 208.364 481.627C207.739 481.517 205.709 481.673 205.709 481.673L204.868 480.031C204.673 479.649 204.257 479.432 203.836 479.475L201.296 479.756C201.296 479.756 201.01 478.501 201 478.469C204.318 477.819 208.273 476.859 209.284 476.079C210.923 474.813 211.587 473.667 211.57 472.339C211.538 469.897 210.108 468.185 209.652 467.27C207.201 462.347 206.301 457.621 206.301 452.174C206.301 437.741 214.483 426 224.541 426H231.15C229.433 426.968 218.462 434.31 218.461 452.174C218.46 463.351 222.364 468.962 223.201 470.461C224.641 473.038 225.295 477.566 222.952 478.923ZM226.01 478.348C226.395 477.397 226.55 476.136 226.371 474.524C227.831 476.094 229.411 477.395 231.099 478.348H226.01ZM238.762 478.348C228.706 478.348 220.524 466.606 220.524 452.174C220.524 437.741 228.706 426 238.762 426C248.818 426 257 437.741 257 452.174C257 466.606 248.818 478.348 238.762 478.348ZM238.762 437.297C232.782 437.297 227.916 443.971 227.916 452.174C227.916 460.382 232.782 467.059 238.762 467.059C244.741 467.059 249.602 460.382 249.602 452.174C249.602 443.971 244.741 437.297 238.762 437.297ZM238.762 464.999C236.491 464.999 234.428 463.725 232.868 461.655C234.428 459.076 235.381 455.781 235.381 452.174C235.381 448.569 234.428 445.275 232.868 442.698C234.428 440.63 236.493 439.357 238.762 439.357C243.602 439.357 247.539 445.107 247.539 452.174C247.539 459.246 243.602 464.999 238.762 464.999Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.479 463.035H285.515C277.518 463.035 271 456.517 271 448.518C271 440.519 277.518 434 285.515 434H301.479C309.477 434 315.963 440.519 315.963 448.518C315.963 456.517 309.477 463.035 301.479 463.035ZM308.815 450.565C307.713 450.565 306.8 449.651 306.8 448.518C306.8 447.384 307.713 446.471 308.815 446.471C309.949 446.471 310.862 447.384 310.862 448.518C310.862 449.651 309.949 450.565 308.815 450.565ZM308.815 447.73C308.406 447.73 308.06 448.077 308.06 448.518C308.06 448.927 308.406 449.305 308.815 449.305C309.256 449.305 309.602 448.927 309.602 448.518C309.602 448.077 309.256 447.73 308.815 447.73ZM278.147 450.565C277.045 450.565 276.132 449.651 276.132 448.518C276.132 447.384 277.045 446.471 278.147 446.471C279.281 446.471 280.194 447.384 280.194 448.518C280.194 449.651 279.281 450.565 278.147 450.565ZM278.147 447.73C277.738 447.73 277.392 448.077 277.392 448.518C277.392 448.927 277.738 449.305 278.147 449.305C278.588 449.305 278.935 448.927 278.935 448.518C278.935 448.077 278.588 447.73 278.147 447.73ZM301.479 459.949H285.515C279.218 459.949 274.086 454.816 274.086 448.518C274.086 442.219 279.218 437.086 285.515 437.086H301.479C304.502 437.086 307.272 438.283 309.319 440.235C309.382 440.267 309.445 440.33 309.477 440.393C311.586 442.471 312.877 445.337 312.877 448.518C312.877 454.816 307.776 459.949 301.479 459.949ZM285.515 438.346C279.911 438.346 275.345 442.912 275.345 448.518C275.345 451.289 276.479 453.777 278.242 455.603H304.313C304.691 455.603 304.974 455.32 304.974 454.942C304.974 454.596 304.691 454.281 304.313 454.281H282.65C281.611 454.281 280.729 453.43 280.729 452.36C280.729 451.32 281.611 450.439 282.65 450.439L304.313 450.47C304.691 450.47 304.974 450.155 304.974 449.809C304.974 449.431 304.691 449.147 304.313 449.147H282.65C281.611 449.147 280.729 448.266 280.729 447.226C280.729 446.156 281.611 445.306 282.65 445.306H304.313C304.691 445.306 304.974 444.991 304.974 444.644C304.974 444.266 304.691 443.983 304.313 443.983H282.65C281.611 443.983 280.729 443.101 280.729 442.062C280.729 440.991 281.611 440.141 282.65 440.141H307.209C305.572 439.007 303.589 438.346 301.479 438.346H285.515ZM279.753 456.863C281.391 457.997 283.374 458.689 285.515 458.689H301.479C307.052 458.689 311.618 454.123 311.618 448.518C311.618 445.746 310.516 443.227 308.721 441.401H282.65C282.304 441.401 281.989 441.684 281.989 442.062C281.989 442.408 282.304 442.723 282.65 442.723H304.313C305.383 442.723 306.233 443.573 306.233 444.644C306.233 445.683 305.383 446.565 304.313 446.565H282.65C282.304 446.565 281.989 446.849 281.989 447.226C281.989 447.573 282.304 447.888 282.65 447.888H304.313C305.383 447.888 306.233 448.738 306.233 449.809C306.233 450.848 305.383 451.73 304.313 451.73H282.65C282.304 451.73 281.989 452.013 281.989 452.36C281.989 452.738 282.304 453.021 282.65 453.021H304.313C305.383 453.021 306.233 453.903 306.233 454.942C306.233 456.013 305.383 456.863 304.313 456.863H279.753Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.952 487.757H285.52C285.174 487.757 284.891 487.474 284.891 487.127V464.075H285.52H289.582V487.127C289.582 487.474 289.299 487.757 288.952 487.757Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.476 487.757H298.044C297.697 487.757 297.414 487.474 297.414 487.127V464.075H301.476H302.106V487.127C302.106 487.474 301.822 487.757 301.476 487.757Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1159 517.064C28.4444 516.393 27.8688 515.433 27.8688 514.282L27.8688 478.59C27.8688 476.287 29.6915 474.464 31.8979 474.56L62.3081 474.464L62.3081 518.408L31.8979 518.312C30.8426 518.408 29.8833 517.832 29.1159 517.064ZM38.4212 511.787C38.1334 511.499 38.0375 511.02 38.2293 510.636L43.5056 497.491L38.9968 497.587C38.709 497.491 38.3253 497.299 38.1334 497.107C37.9415 496.724 37.9415 496.34 38.1334 496.148L46.5753 480.605C46.6713 480.317 47.055 480.125 47.4387 480.125L54.7295 480.125C55.1132 480.125 55.4969 480.317 55.5929 480.605C55.7847 480.988 55.8807 481.276 55.5929 481.564L50.4126 490.583H55.2091C55.5929 490.583 55.9766 490.775 56.1685 491.159C56.2644 491.447 56.1685 491.926 56.0725 492.214L39.8602 511.691C39.5724 512.171 38.9968 512.171 38.6131 511.979C38.5171 511.883 38.5171 511.883 38.4212 511.787ZM45.8079 495.764L45.9038 495.86C46.0957 496.244 46.0957 496.628 45.9998 496.916L42.4503 505.455L53.1946 492.598L48.6858 492.502C48.398 492.598 48.1102 492.31 47.8225 492.022C47.7265 491.734 47.6306 491.447 47.8225 491.063L53.0027 482.044L48.0143 482.044L40.7236 495.476H45.1364C45.3282 495.476 45.616 495.572 45.8079 495.764ZM32.6653 484.922C31.8979 484.155 31.6101 483.099 31.5142 482.044C31.5142 479.741 33.3369 477.918 35.5433 478.014C37.7497 477.918 39.6683 479.837 39.5724 482.044C39.6683 483.099 39.2846 484.059 38.4212 484.922C37.6538 485.69 36.5985 486.17 35.5433 486.074C34.584 486.074 33.4328 485.69 32.6653 484.922ZM35.5433 479.933C34.3921 479.933 33.4328 480.892 33.4328 482.044C33.4328 483.195 34.3921 484.155 35.5433 484.155C36.1189 484.155 36.6944 483.963 37.0782 483.579C37.4619 483.195 37.6538 482.619 37.6538 482.044C37.6538 480.892 36.6944 479.933 35.5433 479.933ZM53.0027 514.09C52.3312 513.418 51.8516 512.363 51.7556 511.308C51.7556 509.005 53.5783 507.182 55.8807 507.182C57.0318 507.182 57.9912 507.566 58.7586 508.333C59.5261 509.101 59.9098 510.252 60.0057 511.308C59.9098 513.514 58.0871 515.337 55.8807 515.433C54.8254 515.337 53.7702 514.858 53.0027 514.09ZM55.8807 509.293C54.6336 509.197 53.7702 510.06 53.7702 511.404C53.7702 512.555 54.6336 513.418 55.8807 513.514C56.9359 513.418 57.8952 512.459 57.9912 511.404C57.9912 510.828 57.7993 510.252 57.4156 509.868C57.0318 509.485 56.4563 509.101 55.8807 509.293ZM64.3226 474.56L67.968 474.56L67.968 518.312L64.2267 518.408L64.3226 474.56ZM69.9825 474.464L71.8052 474.56C74.0117 474.464 75.9303 476.383 75.8343 478.59L75.8343 514.282C75.9303 516.489 74.1076 518.312 71.8052 518.312H69.8866L69.9825 474.464Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8248 504.59C21.633 504.398 21.537 504.11 21.537 503.918L21.537 487.799C21.537 487.607 21.633 487.32 21.8248 487.128C21.9208 487.032 22.2086 486.936 22.4964 486.84L25.9499 486.84L25.9499 504.878L22.4964 504.878C22.2086 504.974 22.0167 504.782 21.8248 504.59Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2024 504.975C74.1064 504.879 74.0105 504.591 73.9146 504.303C74.0105 503.823 74.2983 503.344 74.682 503.344L74.778 488.856C74.2983 488.76 74.0105 488.28 74.0105 487.896C74.0105 487.321 74.4902 486.841 74.9698 486.937H78.9989C79.5745 486.937 79.9582 487.321 79.9582 487.896L80.0542 504.303C80.0542 504.495 79.9582 504.783 79.7664 504.975C79.5745 505.167 79.2867 505.263 79.0949 505.263L75.0658 505.263C74.682 505.263 74.3942 505.167 74.2024 504.975Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2307 500.945C78.1348 500.849 78.0389 500.561 77.9429 500.273C78.0389 499.794 78.3266 499.314 78.9022 499.314L78.8063 492.694C78.3266 492.598 77.9429 492.214 78.0389 491.734C78.0389 491.158 78.4226 490.775 78.9982 490.775L81.5883 490.679C82.5476 490.679 83.411 491.158 84.0825 491.83C84.754 492.502 85.2337 493.365 85.2337 494.325L85.1378 497.683C85.1378 498.642 84.754 499.602 84.1784 500.178C83.5069 500.849 82.6436 501.329 81.5883 501.233L79.0941 501.233C78.7104 501.233 78.4226 501.137 78.2307 500.945Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95489 503.728C6.28338 503.056 5.89965 502.289 5.89965 501.329L5.89965 490.391C5.89965 489.432 6.18745 488.568 6.95489 487.801C7.62641 487.129 8.48979 486.841 9.4491 486.841L15.3968 486.841C17.4114 486.937 18.9463 488.473 18.9463 490.391L18.9463 501.329C18.9463 502.289 18.6585 503.152 17.987 503.824C17.3154 504.496 16.3561 504.879 15.3968 504.879H9.4491C8.39386 504.783 7.62641 504.4 6.95489 503.728Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18307 499.122C6.08714 499.026 5.99121 498.738 5.89528 498.45C5.89527 498.067 6.279 497.683 6.56679 497.587L6.56679 494.325C6.47086 494.229 6.18307 494.133 6.08714 494.037C5.99121 493.941 5.89528 493.653 5.79934 493.365C5.79934 492.79 6.279 492.31 6.85459 492.31L22.4913 492.406C23.0669 492.406 23.4507 492.79 23.4507 493.365C23.5466 493.845 23.1629 494.229 22.6832 494.325L22.7791 497.491C23.2588 497.587 23.5466 498.067 23.5466 498.45C23.5466 499.026 23.0669 499.506 22.4913 499.506L6.95052 499.506C6.56679 499.506 6.37493 499.314 6.18307 499.122ZM6.85459 497.491L22.4913 497.587L22.4913 494.325L6.85459 494.421L6.85459 497.491Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3012 482.812C74.1093 482.62 74.0134 482.333 74.0134 482.141C74.0134 481.565 74.3971 481.181 74.9727 481.181L81.4001 481.085C81.9757 481.085 82.4554 481.565 82.4554 482.141C82.4554 482.716 82.0716 483.1 81.496 483.1L74.9727 483.1C74.6849 483.004 74.3971 482.908 74.3012 482.812Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2053 510.923C74.0134 510.731 73.9175 510.443 74.0134 510.155C73.9175 509.676 74.3971 509.196 74.9727 509.196L81.4001 509.1C81.9757 509.1 82.4553 509.58 82.4553 510.155C82.4553 510.731 81.9757 511.211 81.4001 511.211L74.9727 511.115C74.589 511.115 74.3971 511.115 74.2053 510.923Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.392 503.794C119.392 503.624 119.353 503.456 119.277 503.304L116.159 497.068C115.754 496.25 114.58 496.277 114.196 497.068L111.078 503.304C111.002 503.456 110.962 503.624 110.962 503.794L110.963 534.799L119.393 534.799L119.392 503.794Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.055 545.426L118.29 545.426C118.896 545.426 119.388 544.934 119.388 544.328L119.388 536.995L110.958 536.994L110.958 544.328C110.958 544.934 111.449 545.426 112.055 545.426Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.713 503.792C107.713 503.621 107.673 503.453 107.597 503.301L104.479 497.065C104.074 496.247 102.9 496.275 102.516 497.065L99.3985 503.301C99.3223 503.453 99.2826 503.621 99.2826 503.792L99.2828 534.796L107.713 534.796L107.713 503.792Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.376 545.423L106.61 545.423C107.217 545.423 107.708 544.931 107.708 544.325L107.708 536.992L99.278 536.992L99.278 544.325C99.278 544.931 99.7694 545.423 100.376 545.423Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.635 503.794C130.635 503.624 130.595 503.456 130.519 503.304L127.401 497.068C126.996 496.25 125.822 496.277 125.438 497.068L122.32 503.304C122.244 503.456 122.204 503.624 122.205 503.794L122.205 534.799L130.635 534.799L130.635 503.794Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.305 545.425L129.54 545.425C130.146 545.425 130.638 544.933 130.638 544.327L130.638 536.994L122.208 536.994L122.208 544.327C122.208 544.933 122.699 545.425 123.305 545.425Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.885 503.795C141.885 503.625 141.845 503.457 141.769 503.304L138.651 497.069C138.246 496.251 137.072 496.278 136.688 497.069L133.57 503.304C133.494 503.457 133.454 503.625 133.455 503.795L133.455 534.8L141.885 534.8L141.885 503.795Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.555 545.427L140.79 545.427C141.396 545.427 141.888 544.935 141.888 544.329L141.888 536.995L133.458 536.995L133.458 544.329C133.458 544.935 133.949 545.427 134.555 545.427Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 564.654,
    width: 172.198,
    height: 1.43524,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 571.83,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 567.047,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 574.223,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 569.438,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 576.614,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 564.176,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 571.352,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 566.568,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 573.744,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 568.96,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 576.137,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 566.568,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 566.568)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 573.744,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 573.744)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 568.96,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 568.96)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 576.137,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 576.137)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 571.352,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 571.352)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 578.528,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 578.528)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 565.133,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 572.309,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 567.525,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 574.701,
    width: 2.39163,
    height: 0.478424,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 569.917,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 577.093,
    width: 2.39163,
    height: 0.478424,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 565.611,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 565.611)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 572.787,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 572.787)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 568.004,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 568.004)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 575.18,
    width: 2.39163,
    height: 0.478424,
    transform: "rotate(-180 188.633 575.18)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 570.396,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 570.396)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 577.571,
    width: 2.39163,
    height: 0.478424,
    transform: "rotate(-180 188.633 577.571)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 557.479,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 559.87,
    width: 172.198,
    height: 1.43521,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.26562,
    y: 562.263,
    width: 172.198,
    height: 1.43524,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 557,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 559.393,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.91406,
    y: 561.784,
    width: 5.2616,
    height: 2.39203,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 559.393,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 559.393)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 561.784,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 561.784)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.719,
    y: 564.176,
    width: 5.2616,
    height: 2.39203,
    transform: "rotate(-180 186.719 564.176)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 557.957,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 560.349,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 562.74,
    width: 2.39163,
    height: 0.478394,
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 558.436,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 558.436)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 560.827,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 560.827)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.633,
    y: 563.219,
    width: 2.39163,
    height: 0.478393,
    transform: "rotate(-180 188.633 563.219)",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2848 530V533.68H69.6609V535.152H48.2848V538.832H69.6609V540.304H48.2848V543.984H69.6609V545.456H48.2848V549.136H29.1192V545.456H7.00222V543.984H29.1192V540.304H7.00222V538.832H29.1192V535.152H7.00222C6.94585 534.673 7.98063 533.68 8.10948 533.68H29.1192V530H48.2848Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.44 500.937C202.44 504.768 194.73 507.874 185.22 507.874C175.71 507.874 168 504.768 168 500.937C168 497.106 175.71 494 185.22 494C194.73 494 202.44 497.106 202.44 500.937ZM185.22 502.133C187.597 502.133 189.525 501.49 189.525 500.698C189.525 499.905 187.597 499.262 185.22 499.262C182.842 499.262 180.915 499.905 180.915 500.698C180.915 501.49 182.842 502.133 185.22 502.133Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.111 507.617C194.716 508.984 190.157 509.787 185.22 509.787C180.282 509.787 175.724 508.984 172.329 507.617C170.763 506.986 169.228 506.166 168 504.99V518.626C168 521.616 170.331 522.841 172.766 523.679C180.836 526.457 189.604 526.457 197.674 523.679C200.109 522.841 202.44 521.616 202.44 518.626V504.99C201.212 506.166 199.677 506.986 198.111 507.617Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.906 525.703V545.973C172.906 547.461 173.763 548.667 174.82 548.667C175.876 548.667 176.733 547.461 176.733 545.973V527.167C175.445 526.769 174.168 526.281 172.906 525.703Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.992 527.53V545.992C192.992 547.469 193.849 548.667 194.906 548.667C195.962 548.667 196.819 547.469 196.819 545.992V526.182C195.556 526.72 194.279 527.169 192.992 527.53Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.878 576.025L313.799 559.596C313.803 559.478 313.783 559.361 313.739 559.252C313.696 559.142 313.631 559.043 313.547 558.96C313.463 558.877 313.363 558.813 313.254 558.77C313.144 558.728 313.026 558.709 312.909 558.714L311.908 558.781C311.798 558.781 311.69 558.802 311.588 558.844C311.487 558.886 311.395 558.948 311.318 559.026C311.241 559.104 311.18 559.196 311.139 559.298C311.098 559.4 311.078 559.508 311.079 559.618L311.099 563.73L297.464 563.786L297.415 555.484C297.399 555.353 297.354 555.228 297.285 555.117C297.216 555.005 297.123 554.91 297.013 554.839C296.575 554.539 296.053 554.386 295.522 554.403C294.424 554.408 293.62 554.97 293.623 555.502L293.742 580.313C293.745 580.827 294.554 581.399 295.652 581.394C296.251 581.411 296.833 581.199 297.28 580.801C297.355 580.739 297.416 580.662 297.46 580.575C297.504 580.488 297.529 580.392 297.534 580.295L297.494 571.983L311.12 571.935L311.127 573.282L311.158 576.029C311.155 576.139 311.175 576.249 311.216 576.351C311.258 576.453 311.321 576.545 311.4 576.621C311.562 576.771 311.774 576.856 311.995 576.858L313.058 576.853C313.282 576.843 313.495 576.754 313.659 576.602C313.797 576.44 313.874 576.237 313.878 576.025Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.406 565.126C236.201 565.133 236.006 565.217 235.862 565.363C235.717 565.509 235.634 565.704 235.63 565.91L235.625 566.822L210.916 566.95C210.737 566.949 210.56 566.984 210.395 567.052C210.23 567.12 210.08 567.22 209.955 567.347C209.829 567.474 209.73 567.625 209.663 567.791C209.597 567.956 209.564 568.134 209.567 568.312C209.567 568.491 209.603 568.667 209.672 568.831C209.74 568.995 209.841 569.144 209.968 569.27C210.094 569.395 210.244 569.494 210.409 569.562C210.574 569.629 210.751 569.663 210.929 569.662L235.736 569.542L235.741 570.517C235.747 570.715 235.83 570.902 235.97 571.042C236.111 571.181 236.299 571.261 236.497 571.266L240.041 571.249L240.021 565.126L236.406 565.126Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.099 559.663L285.126 563.411C285.124 563.699 285.01 563.975 284.807 564.18C284.604 564.384 284.33 564.502 284.042 564.506C283.9 564.507 283.759 564.48 283.627 564.427C283.495 564.373 283.376 564.294 283.275 564.194C283.174 564.094 283.094 563.975 283.039 563.844C282.984 563.713 282.956 563.573 282.956 563.43L282.937 559.673L277.081 559.71L277.111 565.966C277.113 566.255 276.999 566.533 276.796 566.738C276.592 566.944 276.316 567.06 276.027 567.062C275.886 567.063 275.746 567.037 275.615 566.984C275.484 566.931 275.365 566.852 275.265 566.753C275.165 566.654 275.085 566.536 275.031 566.406C274.977 566.275 274.949 566.136 274.95 565.994L274.911 559.712L269.028 559.74L269.063 563.497C269.059 563.782 268.945 564.055 268.744 564.257C268.544 564.46 268.273 564.577 267.988 564.584C267.847 564.585 267.707 564.559 267.576 564.506C267.445 564.453 267.326 564.375 267.226 564.275C267.126 564.176 267.046 564.058 266.992 563.928C266.938 563.797 266.91 563.658 266.911 563.517L266.875 559.742L260.966 559.815L261.005 566.097C261.021 566.25 261.005 566.404 260.957 566.55C260.909 566.696 260.831 566.83 260.727 566.943C260.623 567.056 260.496 567.146 260.355 567.206C260.213 567.266 260.061 567.295 259.907 567.291C259.754 567.288 259.603 567.251 259.465 567.184C259.326 567.117 259.204 567.022 259.106 566.904C259.007 566.786 258.935 566.648 258.895 566.5C258.854 566.352 258.845 566.197 258.869 566.045L258.839 559.772L252.956 559.8L252.992 563.557C252.988 563.842 252.873 564.114 252.673 564.317C252.472 564.519 252.201 564.636 251.916 564.643C251.773 564.646 251.63 564.619 251.497 564.566C251.364 564.512 251.242 564.432 251.14 564.331C251.038 564.23 250.958 564.11 250.903 563.977C250.848 563.844 250.82 563.702 250.821 563.559L250.874 559.872L244.176 559.904L244.071 560.011C243.314 561.35 242.72 562.775 242.301 564.255L242.302 564.415L242.214 564.504L242.214 564.61C241.932 565.756 241.792 566.932 241.797 568.112C241.803 569.311 241.961 570.504 242.266 571.664C242.321 571.796 242.354 571.937 242.366 572.08C242.783 573.54 243.388 574.94 244.166 576.245L244.273 576.35L291.398 576.203L291.319 559.633L285.099 559.663Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.115 541.445C272.813 541.542 273.22 541.57 273.086 540.665C272.183 534.556 273.212 524.469 265.004 523.706C254.425 522.724 242.056 524.276 231.306 523.974C228.997 524.572 229.139 525.645 228.113 527.06C227.679 527.658 226.753 527.789 226.619 528.27C225.767 531.333 226.063 536.23 225.131 539.723C224.891 540.622 225.499 541.169 224.016 540.924C223.802 537.374 225.772 532.523 225.618 529.204C225.559 527.923 224.689 526.969 224.521 525.568C223.991 521.193 223.996 508.553 224.524 504.171C225.216 498.426 228.401 499.907 232.05 499.178C246.591 496.277 251.557 496.271 266.082 499.178C269.318 499.824 273.001 498.52 273.608 503.65C274.286 509.37 273.922 520.091 273.625 526.101C273.568 527.245 272.656 527.851 272.607 528.649C272.396 532.079 274.757 537.639 274.113 541.445H274.115ZM244.887 498.19C241.514 497.715 238.336 499.141 235.194 499.713C233.104 500.095 230.473 499.377 228.426 500.772C226.223 502.272 226.471 506.793 227.149 509.13L228.837 501.962C234.039 501.279 238.923 499.986 244.106 499.218C245.015 499.084 244.984 499.491 244.887 498.19Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 508V519.469H311.236V530.558L315.998 530.176L316 534H289.002L289 530.556L293.766 530.558V519.469L289.002 519.851V508H316Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 507H293V499.529C293.602 498.89 294.95 497.682 295.663 497.419C296.986 496.931 308.447 496.882 310.15 497.204C310.733 497.314 313 498.792 313 499.102V507ZM305.504 503.752C305.504 502.243 304.424 501.021 303.091 501.021C301.757 501.021 300.677 502.243 300.677 503.752C300.677 505.261 301.757 506.482 303.091 506.482C304.424 506.482 305.504 505.261 305.504 503.752Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 519H289V529H294V519Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 519H313V529H316V519Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.008 538.067L295 537.845L295.212 534L297.98 534.004L298 537.845L296.993 538.067V547H296.008V538.067Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.164 538.674C302.069 538.355 301.169 538.226 301.071 537.778C300.849 536.777 301.235 535.12 301.076 534H303.978L304 537.845L302.89 538.064V547L301.804 546.996C301.624 546.854 302.166 546.476 302.166 546.39C302.166 544.859 302.445 539.613 302.166 538.672L302.164 538.674Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.507 538.067L307 537.845L307.314 534L310.97 534.004L311 537.845L309.493 538.067V547H308.507V538.067Z",
    fill: "#81D4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 506C303.881 506 305 504.881 305 503.5C305 502.119 303.881 501 302.5 501C301.119 501 300 502.119 300 503.5C300 504.881 301.119 506 302.5 506Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_44154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 642,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKits);
export default __webpack_public_path__ + "static/media/kits.fb29fbe4e96d5c08d2e6dc4a6cd3c48f.svg";
export { ForwardRef as ReactComponent };